/* Babelio gallery fix; based on the live theme asset inspected 2026-09-18. */
/*
Generated time: February 3, 2026 06:35
This file was created by the app developer. Feel free to contact the original developer with any questions. It was minified (compressed) by AVADA. AVADA do NOT own this script.
*/
(() => {
  var B = Object.defineProperty,
    e = (e, t, i) => {
      var s;
      return s = i, (t = "symbol" != typeof t ? t + "" : t) in (e = e) ? B(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
      }) : e[t] = s, i;
    };
  function t(e) {
    this.listenerMap = [{}, {}], e && this.root(e), this.handle = t.prototype.handle.bind(this), this._removedListeners = [];
  }
  function H(e, t) {
    return e.toLowerCase() === t.tagName.toLowerCase();
  }
  function D(e, t) {
    return e === t.id;
  }
  t.prototype.root = function (e) {
    var t = this.listenerMap;
    let i;
    if (this.rootElement) {
      for (i in t[1]) t[1].hasOwnProperty(i) && this.rootElement.removeEventListener(i, this.handle, !0);
      for (i in t[0]) t[0].hasOwnProperty(i) && this.rootElement.removeEventListener(i, this.handle, !1);
    }
    if (e && e.addEventListener) {
      for (i in this.rootElement = e, t[1]) t[1].hasOwnProperty(i) && this.rootElement.addEventListener(i, this.handle, !0);
      for (i in t[0]) t[0].hasOwnProperty(i) && this.rootElement.addEventListener(i, this.handle, !1);
    } else this.rootElement && delete this.rootElement;
    return this;
  }, t.prototype.captureForType = function (e) {
    return -1 !== ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(e);
  }, t.prototype.on = function (e, t, i, s) {
    var n, a;
    let r, o;
    if (!e) throw new TypeError("Invalid event type: " + e);
    if ("function" == typeof t && (s = i, i = t, t = null), void 0 === s && (s = this.captureForType(e)), "function" != typeof i) throw new TypeError("Handler must be a type of Function");
    return n = this.rootElement, (a = this.listenerMap[s ? 1 : 0])[e] || (n && n.addEventListener(e, this.handle, s), a[e] = []), r = t ? /^[a-z]+$/i.test(t) ? (o = t, H) : /^#[a-z0-9\-_]+$/i.test(t) ? (o = t.slice(1), D) : (o = t, Element.prototype.matches) : (o = null, function (e, t) {
      return this.rootElement !== window ? this.rootElement === t : t === document || t === document.documentElement || t === window;
    }.bind(this)), a[e].push({
      selector: t,
      handler: i,
      matcher: r,
      matcherParam: o
    }), this;
  }, t.prototype.off = function (e, t, i, s) {
    let n;
    var a, r, o;
    let l;
    if ("function" == typeof t && (s = i, i = t, t = null), void 0 === s) this.off(e, t, i, !0), this.off(e, t, i, !1);else if (r = this.listenerMap[s ? 1 : 0], e) {
      if ((o = r[e]) && o.length) {
        for (n = o.length - 1; 0 <= n; n--) a = o[n], t && t !== a.selector || i && i !== a.handler || (this._removedListeners.push(a), o.splice(n, 1));
        o.length || (delete r[e], this.rootElement && this.rootElement.removeEventListener(e, this.handle, s));
      }
    } else for (l in r) r.hasOwnProperty(l) && this.off(l, t, i);
    return this;
  }, t.prototype.handle = function (i) {
    let s, n;
    var a,
      r,
      o = i.type;
    let l = [],
      d;
    var c = "ftLabsDelegateIgnore";
    if (!0 !== i[c]) {
      switch ((d = 3 === (d = i.target).nodeType ? d.parentNode : d).correspondingUseElement && (d = d.correspondingUseElement), a = this.rootElement, i.eventPhase || (i.target !== i.currentTarget ? 3 : 2)) {
        case 1:
          l = this.listenerMap[1][o];
          break;
        case 2:
          this.listenerMap[0] && this.listenerMap[0][o] && (l = l.concat(this.listenerMap[0][o])), this.listenerMap[1] && this.listenerMap[1][o] && (l = l.concat(this.listenerMap[1][o]));
          break;
        case 3:
          l = this.listenerMap[0][o];
      }
      let e = [];
      for (n = l.length; d && n;) {
        for (s = 0; s < n && (r = l[s]); s++) d.tagName && -1 < ["button", "input", "select", "textarea"].indexOf(d.tagName.toLowerCase()) && d.hasAttribute("disabled") ? e = [] : r.matcher.call(d, r.matcherParam, d) && e.push([i, d, r]);
        if (d === a) break;
        if (n = l.length, (d = d.parentElement || d.parentNode) instanceof HTMLDocument) break;
      }
      let t;
      for (s = 0; s < e.length; s++) if (!(-1 < this._removedListeners.indexOf(e[s][2])) && !1 === this.fire.apply(this, e[s])) {
        e[s][0][c] = !0, e[s][0].preventDefault(), t = !1;
        break;
      }
      return t;
    }
  }, t.prototype.fire = function (e, t, i) {
    return i.handler.call(t, e, t);
  }, t.prototype.destroy = function () {
    this.off(), this.root();
  };
  var i = t,
    R = class {
      constructor() {
        this.delegateElement = new i(document.body), this.delegateElement.on("change", "[data-bind-value]", this._onValueChanged.bind(this));
      }
      _onValueChanged(e, t) {
        var i = document.getElementById(t.getAttribute("data-bind-value"));
        i && ("SELECT" === t.tagName && (t = t.options[t.selectedIndex]), i.innerHTML = t.hasAttribute("title") ? t.getAttribute("title") : t.value);
      }
    };
  function n(e, t, i = {}) {
    e.dispatchEvent(new CustomEvent(t, {
      bubbles: !0,
      detail: i
    }));
  }
  function s(e, t, i = {}) {
    e.dispatchEvent(new CustomEvent(t, {
      bubbles: !1,
      detail: i
    }));
  }
  var a = class extends HTMLElement {
      constructor() {
        super(), this._hasSectionReloaded = !1, Shopify.designMode && this.rootDelegate.on("shopify:section:select", e => {
          var t = this.closest(".shopify-section");
          e.target === t && e.detail.load && (this._hasSectionReloaded = !0);
        });
      }
      get rootDelegate() {
        return this._rootDelegate = this._rootDelegate || new i(document.documentElement);
      }
      get delegate() {
        return this._delegate = this._delegate || new i(this);
      }
      showLoadingBar() {
        n(document.documentElement, "theme:loading:start");
      }
      hideLoadingBar() {
        n(document.documentElement, "theme:loading:end");
      }
      untilVisible(e = {
        rootMargin: "30px 0px",
        threshold: 0
      }) {
        let i = () => {
          this.classList.add("became-visible"), this.style.opacity = "1";
        };
        return new Promise(t => {
          window.IntersectionObserver ? (this.intersectionObserver = new IntersectionObserver(e => {
            e[0].isIntersecting && (this.intersectionObserver.disconnect(), requestAnimationFrame(() => {
              t(), i();
            }));
          }, e), this.intersectionObserver.observe(this)) : (t(), i());
        });
      }
      disconnectedCallback() {
        var e;
        this.delegate.destroy(), this.rootDelegate.destroy(), null != (e = this.intersectionObserver) && e.disconnect(), delete this._delegate, delete this._rootDelegate;
      }
    },
    r = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"],
    o = r.join(","),
    y = "undefined" == typeof Element ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector,
    N = function (e, t, i) {
      var s = Array.prototype.slice.apply(e.querySelectorAll(o));
      return t && y.call(e, o) && s.unshift(e), s = s.filter(i);
    },
    F = function (e) {
      return "true" === e.contentEditable;
    },
    _ = function (e) {
      var t = parseInt(e.getAttribute("tabindex"), 10);
      return isNaN(t) ? !F(e) && ("AUDIO" !== e.nodeName && "VIDEO" !== e.nodeName && "DETAILS" !== e.nodeName || null !== e.getAttribute("tabindex")) ? e.tabIndex : 0 : t;
    },
    $ = function (e, t) {
      return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
    },
    l = function (e) {
      return "INPUT" === e.tagName;
    },
    z = function (e) {
      return l(e) && "hidden" === e.type;
    },
    W = function (e) {
      return "DETAILS" === e.tagName && Array.prototype.slice.apply(e.children).some(function (e) {
        return "SUMMARY" === e.tagName;
      });
    },
    Y = function (e, t) {
      for (var i = 0; i < e.length; i++) if (e[i].checked && e[i].form === t) return e[i];
    },
    U = function (e) {
      if (!e.name) return !0;
      function t(e) {
        return i.querySelectorAll('input[type="radio"][name="' + e + '"]');
      }
      var i = e.form || e.ownerDocument;
      if ("undefined" != typeof window && void 0 !== window.CSS && "function" == typeof window.CSS.escape) s = t(window.CSS.escape(e.name));else try {
        s = t(e.name);
      } catch (e) {
        return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", e.message), !1;
      }
      var s = Y(s, e.form);
      return !s || s === e;
    },
    j = function (e) {
      return l(e) && "radio" === e.type;
    },
    X = function (e) {
      return j(e) && !U(e);
    },
    G = function (e, t) {
      if ("hidden" === getComputedStyle(e).visibility) return !0;
      var i = y.call(e, "details>summary:first-of-type") ? e.parentElement : e;
      if (y.call(i, "details:not([open]) *")) return !0;
      if (t && "full" !== t) {
        if ("non-zero-area" === t) return 0 === (i = e.getBoundingClientRect()).width && 0 === i.height;
      } else for (; e;) {
        if ("none" === getComputedStyle(e).display) return !0;
        e = e.parentElement;
      }
      return !1;
    },
    Z = function (e) {
      if (l(e) || "SELECT" === e.tagName || "TEXTAREA" === e.tagName || "BUTTON" === e.tagName) for (var t = e.parentElement; t;) {
        if ("FIELDSET" === t.tagName && t.disabled) {
          for (var i = 0; i < t.children.length; i++) {
            var s = t.children.item(i);
            if ("LEGEND" === s.tagName) return !s.contains(e);
          }
          return !0;
        }
        t = t.parentElement;
      }
      return !1;
    },
    Q = function (e, t) {
      return !(t.disabled || z(t) || G(t, e.displayCheck) || W(t) || Z(t));
    },
    K = function (e, t) {
      return !(!Q(e, t) || X(t) || _(t) < 0);
    },
    J = r.concat("iframe").join(",");
  function ee(t, e) {
    var i,
      s = Object.keys(t);
    return Object.getOwnPropertySymbols && (i = Object.getOwnPropertySymbols(t), e && (i = i.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), s.push.apply(s, i)), s;
  }
  function te(s) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? ee(Object(n), !0).forEach(function (e) {
        var t, i;
        t = s, i = n[e = e], e in t ? Object.defineProperty(t, e, {
          value: i,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = i;
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(n)) : ee(Object(n)).forEach(function (e) {
        Object.defineProperty(s, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }
    return s;
  }
  function ie(e) {
    return setTimeout(e, 0);
  }
  function E(e, i) {
    var s = -1;
    return e.every(function (e, t) {
      return !i(e) || (s = t, !1);
    }), s;
  }
  function x(e) {
    for (var t = arguments.length, i = new Array(1 < t ? t - 1 : 0), s = 1; s < t; s++) i[s - 1] = arguments[s];
    return "function" == typeof e ? e.apply(void 0, i) : e;
  }
  function S(e) {
    return e.target.shadowRoot && "function" == typeof e.composedPath ? e.composedPath()[0] : e.target;
  }
  function se(e, t) {
    function a(e, t, i) {
      return e && void 0 !== e[t] ? e[t] : d[i || t];
    }
    function r(e) {
      var t = h("setReturnFocus", e);
      return t || !1 !== t && e;
    }
    function n() {
      if (c.active) ne.activateTrap(w), c.delayInitialFocusTimer = d.delayInitialFocus ? ie(function () {
        m(u());
      }) : m(u()), l.addEventListener("focusin", b, !0), l.addEventListener("mousedown", i, {
        capture: !0,
        passive: !1
      }), l.addEventListener("touchstart", i, {
        capture: !0,
        passive: !1
      }), l.addEventListener("click", v, {
        capture: !0,
        passive: !1
      }), l.addEventListener("keydown", f, {
        capture: !0,
        passive: !1
      });
    }
    function o() {
      if (c.active) l.removeEventListener("focusin", b, !0), l.removeEventListener("mousedown", i, !0), l.removeEventListener("touchstart", i, !0), l.removeEventListener("click", v, !0), l.removeEventListener("keydown", f, !0);
    }
    var l = (null == t ? void 0 : t.document) || document,
      d = te({
        returnFocusOnDeactivate: !0,
        escapeDeactivates: !0,
        delayInitialFocus: !0
      }, t),
      c = {
        containers: [],
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: !1,
        paused: !1,
        delayInitialFocusTimer: void 0
      },
      s = function (t) {
        return !(!t || !c.containers.some(function (e) {
          return e.contains(t);
        }));
      },
      h = function (e) {
        var t = d[e];
        if ("function" == typeof t) {
          for (var i = arguments.length, s = new Array(1 < i ? i - 1 : 0), n = 1; n < i; n++) s[n - 1] = arguments[n];
          t = t.apply(void 0, s);
        }
        if (!t) {
          if (void 0 === t || !1 === t) return t;
          throw new Error("`".concat(e, "` was specified but was not a node, or did not return a node"));
        }
        var a = t;
        if ("string" != typeof t || (a = l.querySelector(t))) return a;
        throw new Error("`".concat(e, "` as selector refers to no known node"));
      },
      u = function () {
        var e,
          t = h("initialFocus");
        if (!1 === t) return !1;
        if (t = void 0 === t ? s(l.activeElement) ? l.activeElement : (e = c.tabbableGroups[0]) && e.firstTabbableNode || h("fallbackFocus") : t) return t;
        throw new Error("Your focus-trap needs to have at least one focusable element");
      },
      p = function () {
        if (c.tabbableGroups = c.containers.map(function (e) {
          s = [], n = [], N(e, (t = t || {}).includeContainer, K.bind(null, t)).forEach(function (e, t) {
            var i = _(e);
            0 === i ? s.push(e) : n.push({
              documentOrder: t,
              tabIndex: i,
              node: e
            });
          });
          var s,
            n,
            t = n.sort($).map(function (e) {
              return e.node;
            }).concat(s);
          if (0 < t.length) return {
            container: e,
            firstTabbableNode: t[0],
            lastTabbableNode: t[t.length - 1]
          };
        }).filter(function (e) {
          return !!e;
        }), c.tabbableGroups.length <= 0 && !h("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
      },
      m = function e(t) {
        var i;
        !1 !== t && t !== l.activeElement && (t && t.focus ? (t.focus({
          preventScroll: !!d.preventScroll
        }), c.mostRecentlyFocusedNode = t, (i = t).tagName && "input" === i.tagName.toLowerCase() && "function" == typeof i.select && t.select()) : e(u()));
      },
      i = function (e) {
        var t = S(e);
        s(t) || (x(d.clickOutsideDeactivates, e) ? w.deactivate({
          returnFocus: d.returnFocusOnDeactivate && !((e, t) => {
            if (t = t || {}, e) return !1 !== y.call(e, J) && Q(t, e);
            throw new Error("No node provided");
          })(t)
        }) : x(d.allowOutsideClick, e) || e.preventDefault());
      },
      b = function (e) {
        var t = S(e),
          i = s(t);
        i || t instanceof Document ? i && (c.mostRecentlyFocusedNode = t) : (e.stopImmediatePropagation(), m(c.mostRecentlyFocusedNode || u()));
      },
      g = function (e) {
        var t,
          i,
          s = S(e),
          n = (p(), null);
        0 < c.tabbableGroups.length ? (i = E(c.tabbableGroups, function (e) {
          return e.container.contains(s);
        })) < 0 ? n = e.shiftKey ? c.tabbableGroups[c.tabbableGroups.length - 1].lastTabbableNode : c.tabbableGroups[0].firstTabbableNode : e.shiftKey ? 0 <= (t = (t = E(c.tabbableGroups, function (e) {
          e = e.firstTabbableNode;
          return s === e;
        })) < 0 && c.tabbableGroups[i].container === s ? i : t) && (t = 0 === t ? c.tabbableGroups.length - 1 : t - 1, n = c.tabbableGroups[t].lastTabbableNode) : 0 <= (t = (t = E(c.tabbableGroups, function (e) {
          e = e.lastTabbableNode;
          return s === e;
        })) < 0 && c.tabbableGroups[i].container === s ? i : t) && (i = t === c.tabbableGroups.length - 1 ? 0 : t + 1, n = c.tabbableGroups[i].firstTabbableNode) : n = h("fallbackFocus"), n && (e.preventDefault(), m(n));
      },
      f = function (e) {
        var t;
        "Escape" !== (t = e).key && "Esc" !== t.key && 27 !== t.keyCode || !1 === x(d.escapeDeactivates, e) ? "Tab" !== (t = e).key && 9 !== t.keyCode || g(e) : (e.preventDefault(), w.deactivate());
      },
      v = function (e) {
        var t;
        x(d.clickOutsideDeactivates, e) || (t = S(e), s(t)) || x(d.allowOutsideClick, e) || (e.preventDefault(), e.stopImmediatePropagation());
      },
      w = {
        activate: function (e) {
          var t, i, s;
          return c.active || (t = a(e, "onActivate"), i = a(e, "onPostActivate"), (s = a(e, "checkCanFocusTrap")) || p(), c.active = !0, c.paused = !1, c.nodeFocusedBeforeActivation = l.activeElement, t && t(), e = function () {
            s && p(), n(), i && i();
          }, s ? s(c.containers.concat()).then(e, e) : e()), this;
        },
        deactivate: function (e) {
          var t, i, s, n;
          return c.active && (clearTimeout(c.delayInitialFocusTimer), c.delayInitialFocusTimer = void 0, o(), c.active = !1, c.paused = !1, ne.deactivateTrap(w), n = a(e, "onDeactivate"), t = a(e, "onPostDeactivate"), i = a(e, "checkCanReturnFocus"), n && n(), n = function () {
            ie(function () {
              s && m(r(c.nodeFocusedBeforeActivation)), t && t();
            });
          }, (s = a(e, "returnFocus", "returnFocusOnDeactivate")) && i ? i(r(c.nodeFocusedBeforeActivation)).then(n, n) : n()), this;
        },
        pause: function () {
          return !c.paused && c.active && (c.paused = !0, o()), this;
        },
        unpause: function () {
          return c.paused && c.active && (c.paused = !1, p(), n()), this;
        },
        updateContainerElements: function (e) {
          e = [].concat(e).filter(Boolean);
          return c.containers = e.map(function (e) {
            return "string" == typeof e ? l.querySelector(e) : e;
          }), c.active && p(), this;
        }
      };
    return w.updateContainerElements(e), w;
  }
  d = [];
  var d,
    ne = {
      activateTrap: function (e) {
        0 < d.length && (t = d[d.length - 1]) !== e && t.pause();
        var t = d.indexOf(e);
        -1 !== t && d.splice(t, 1), d.push(e);
      },
      deactivateTrap: function (e) {
        e = d.indexOf(e);
        -1 !== e && d.splice(e, 1), 0 < d.length && d[d.length - 1].unpause();
      }
    };
  function c(e, t, i) {
    let s = !1;
    e.type.includes("shopify:section") ? t.hasAttribute("section") && t.getAttribute("section") === e.detail.sectionId && (s = !0) : e.type.includes("shopify:block") && e.target === t && (s = !0), s && i(e);
  }
  var r = class extends a {
      static get observedAttributes() {
        return ["open"];
      }
      constructor() {
        var e;
        super(), Shopify.designMode && (this.rootDelegate.on("shopify:section:select", e => c(e, this, () => this.open = !0)), this.rootDelegate.on("shopify:section:deselect", e => c(e, this, () => this.open = !1))), this.hasAttribute("append-body") && (e = document.getElementById(this.id), this.removeAttribute("append-body"), e && e !== this ? (e.replaceWith(this.cloneNode(!0)), this.remove()) : document.body.appendChild(this));
      }
      connectedCallback() {
        this.delegate.on("click", ".openable__overlay", () => this.open = !1), this.delegate.on("click", '[data-action="close"]', e => {
          e.stopPropagation(), this.open = !1;
        });
      }
      get requiresLoading() {
        return this.hasAttribute("href");
      }
      get open() {
        return this.hasAttribute("open");
      }
      set open(e) {
        e ? (async () => {
          await this._load(), this.clientWidth, this.setAttribute("open", "");
        })() : this.removeAttribute("open");
      }
      get shouldTrapFocus() {
        return !0;
      }
      get returnFocusOnDeactivate() {
        return !this.hasAttribute("return-focus") || "true" === this.getAttribute("return-focus");
      }
      get focusTrap() {
        return this._focusTrap = this._focusTrap || se(this, {
          fallbackFocus: this,
          initialFocus: this.hasAttribute("initial-focus-selector") ? this.getAttribute("initial-focus-selector") : void 0,
          clickOutsideDeactivates: e => !(e.target.hasAttribute("aria-controls") && e.target.getAttribute("aria-controls") === this.id),
          allowOutsideClick: e => e.target.hasAttribute("aria-controls") && e.target.getAttribute("aria-controls") === this.id,
          returnFocusOnDeactivate: this.returnFocusOnDeactivate,
          onDeactivate: () => this.open = !1,
          preventScroll: !0
        });
      }
      attributeChangedCallback(e, t, i) {
        "open" === e && (null === t && "" === i ? (this.shouldTrapFocus && setTimeout(() => this.focusTrap.activate(), 150), n(this, "openable-element:open")) : null === i && (this.shouldTrapFocus && this.focusTrap.deactivate(), n(this, "openable-element:close")));
      }
      async _load() {
        var e, t;
        this.requiresLoading && (s(this, "openable-element:load:start"), e = await fetch(this.getAttribute("href")), (t = document.createElement("div")).innerHTML = await e.text(), this.innerHTML = t.querySelector(this.tagName.toLowerCase()).innerHTML, this.removeAttribute("href"), s(this, "openable-element:load:end"));
      }
    },
    h = (window.customElements.define("openable-element", r), class extends r {
      constructor() {
        super(), this.ignoreNextTransition = this.open, this.addEventListener("shopify:block:select", () => this.open = !0), this.addEventListener("shopify:block:deselect", () => this.open = !1);
      }
      get animateItems() {
        return this.hasAttribute("animate-items");
      }
      attributeChangedCallback(e) {
        if (this.ignoreNextTransition) return this.ignoreNextTransition = !1;
        "open" === e && (this.style.overflow = "hidden", e = {
          height: ["0px", this.scrollHeight + "px"],
          visibility: ["hidden", "visible"]
        }, this.animateItems && (e.opacity = this.open ? [0, 0] : [0, 1]), this.animate(e, {
          duration: 500,
          direction: this.open ? "normal" : "reverse",
          easing: "cubic-bezier(0.75, 0, 0.175, 1)"
        }).onfinish = () => {
          this.style.overflow = this.open ? "visible" : "hidden";
        }, this.animateItems && this.open && this.animate({
          opacity: [0, 1],
          transform: ["translateY(10px)", "translateY(0)"]
        }, {
          duration: 250,
          delay: 250,
          easing: "cubic-bezier(0.75, 0, 0.175, 1)"
        }), n(this, this.open ? "openable-element:open" : "openable-element:close"));
      }
    }),
    h = (window.customElements.define("collapsible-content", h), class extends HTMLButtonElement {
      connectedCallback() {
        this.addEventListener("click", e => {
          window.confirm(this.getAttribute("data-message") || "Are you sure you wish to do this?") || e.preventDefault();
        });
      }
    }),
    h = (window.customElements.define("confirm-button", h, {
      extends: "button"
    }), {
      _prepareButton() {
        this.originalContent = this.innerHTML, this._startTransitionPromise = null, this.innerHTML = `
      <span class="loader-button__text">${this.innerHTML}</span>
      <span class="loader-button__loader" hidden>
        <div class="spinner">
          <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
            <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
          </svg>
        </div>
      </span>
    `, this.textElement = this.firstElementChild, this.spinnerElement = this.lastElementChild, window.addEventListener("pagehide", () => this.removeAttribute("aria-busy"));
      },
      _startTransition() {
        let t = this.textElement.animate({
            opacity: [1, 0],
            transform: ["translateY(0)", "translateY(-10px)"]
          }, {
            duration: 75,
            easing: "ease",
            fill: "forwards"
          }),
          i = (this.spinnerElement.hidden = !1, this.spinnerElement.animate({
            opacity: [0, 1],
            transform: ["translate(-50%, 0%)", "translate(-50%, -50%)"]
          }, {
            duration: 75,
            delay: 75,
            easing: "ease",
            fill: "forwards"
          }));
        this._startTransitionPromise = Promise.all([new Promise(e => t.onfinish = () => e()), new Promise(e => i.onfinish = () => e())]);
      },
      async _endTransition() {
        this._startTransitionPromise && (await this._startTransitionPromise, this.spinnerElement.animate({
          opacity: [1, 0],
          transform: ["translate(-50%, -50%)", "translate(-50%, -100%)"]
        }, {
          duration: 75,
          delay: 100,
          easing: "ease",
          fill: "forwards"
        }).onfinish = () => this.spinnerElement.hidden = !0, this.textElement.animate({
          opacity: [0, 1],
          transform: ["translateY(10px)", "translateY(0)"]
        }, {
          duration: 75,
          delay: 175,
          easing: "ease",
          fill: "forwards"
        }), this._startTransitionPromise = null);
      }
    }),
    u = class extends HTMLButtonElement {
      static get observedAttributes() {
        return ["aria-busy"];
      }
      constructor() {
        super(), this.addEventListener("click", e => {
          "submit" === this.type && this.form && this.form.checkValidity() && !this.form.hasAttribute("is") && (/^((?!chrome|android).)*safari/i.test(navigator.userAgent) ? (e.preventDefault(), this.setAttribute("aria-busy", "true"), setTimeout(() => this.form.submit(), 250)) : this.setAttribute("aria-busy", "true"));
        });
      }
      connectedCallback() {
        this._prepareButton();
      }
      disconnectedCallback() {
        this.innerHTML = this.originalContent;
      }
      attributeChangedCallback(e, t, i) {
        "aria-busy" === e && ("true" === i ? this._startTransition() : this._endTransition());
      }
    },
    u = (Object.assign(u.prototype, h), window.customElements.define("loader-button", u, {
      extends: "button"
    }), class extends a {
      connectedCallback() {
        this.hasAttribute("ajax") && this.delegate.on("click", "a", this._onLinkClicked.bind(this));
      }
      _onLinkClicked(e, t) {
        e.preventDefault();
        e = new URL(window.location.href);
        e.searchParams.set("page", t.getAttribute("data-page")), n(this, "pagination:page-changed", {
          url: e.toString()
        });
      }
    }),
    u = (window.customElements.define("page-pagination", u), class extends HTMLButtonElement {
      static get observedAttributes() {
        return ["aria-expanded", "aria-busy"];
      }
      constructor() {
        super(), this.hasAttribute("loader") && this._prepareButton(), this.addEventListener("click", this._onButtonClick.bind(this)), this.rootDelegate = new i(document.documentElement);
      }
      _onButtonClick() {
        this.isExpanded = !this.isExpanded;
      }
      connectedCallback() {
        document.addEventListener("openable-element:close", e => {
          this.controlledElement === e.target && (this.isExpanded = !1, e.stopPropagation());
        }), document.addEventListener("openable-element:open", e => {
          this.controlledElement === e.target && (this.isExpanded = !0, e.stopPropagation());
        }), this.rootDelegate.on("openable-element:load:start", "#" + this.getAttribute("aria-controls"), () => {
          this.classList.contains("button") ? this.setAttribute("aria-busy", "true") : null !== this.offsetParent && n(document.documentElement, "theme:loading:start");
        }, !0), this.rootDelegate.on("openable-element:load:end", "#" + this.getAttribute("aria-controls"), () => {
          this.classList.contains("button") ? this.removeAttribute("aria-busy") : null !== this.offsetParent && n(document.documentElement, "theme:loading:end");
        }, !0);
      }
      disconnectedCallback() {
        this.rootDelegate.destroy();
      }
      get isExpanded() {
        return "true" === this.getAttribute("aria-expanded");
      }
      set isExpanded(e) {
        this.setAttribute("aria-expanded", e ? "true" : "false");
      }
      get controlledElement() {
        return document.getElementById(this.getAttribute("aria-controls"));
      }
      attributeChangedCallback(e, t, i) {
        switch (e) {
          case "aria-expanded":
            "false" === t && "true" === i ? this.controlledElement.open = !0 : "true" === t && "false" === i && (this.controlledElement.open = !1);
            break;
          case "aria-busy":
            this.hasAttribute("loader") && ("true" === i ? this._startTransition() : this._endTransition());
        }
      }
    }),
    h = (Object.assign(u.prototype, h), window.customElements.define("toggle-button", u, {
      extends: "button"
    }), class extends HTMLAnchorElement {
      static get observedAttributes() {
        return ["aria-expanded"];
      }
      constructor() {
        super(), this.addEventListener("click", e => {
          e.preventDefault(), this.isExpanded = !this.isExpanded;
        }), this.rootDelegate = new i(document.documentElement);
      }
      connectedCallback() {
        this.rootDelegate.on("openable-element:close", "#" + this.getAttribute("aria-controls"), e => {
          this.controlledElement === e.target && (this.isExpanded = !1);
        }, !0), this.rootDelegate.on("openable-element:open", "#" + this.getAttribute("aria-controls"), e => {
          this.controlledElement === e.target && (this.isExpanded = !0);
        }, !0);
      }
      disconnectedCallback() {
        this.rootDelegate.destroy();
      }
      get isExpanded() {
        return "true" === this.getAttribute("aria-expanded");
      }
      set isExpanded(e) {
        this.setAttribute("aria-expanded", e ? "true" : "false");
      }
      get controlledElement() {
        return document.querySelector("#" + this.getAttribute("aria-controls"));
      }
      attributeChangedCallback(e, t, i) {
        "aria-expanded" === e && ("false" === t && "true" === i ? this.controlledElement.open = !0 : "true" === t && "false" === i && (this.controlledElement.open = !1));
      }
    }),
    h = (window.customElements.define("toggle-link", h, {
      extends: "a"
    }), class extends a {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll("button")), this.delegate.on("click", "button", (e, t) => {
          this._dispatchEvent(this.buttons.indexOf(t));
        }), this.hasAttribute("animation-timer") && this.delegate.on("animationend", e => {
          0 < e.elapsedTime && this._dispatchEvent((this.selectedIndex + 1 + this.buttons.length) % this.buttons.length);
        });
      }
      get selectedIndex() {
        return this.buttons.findIndex(e => "true" === e.getAttribute("aria-current"));
      }
      set selectedIndex(i) {
        var e, t, s;
        this.buttons.forEach((e, t) => e.setAttribute("aria-current", i === t ? "true" : "false")), this.hasAttribute("align-selected") && (t = this.buttons[i], e = window.innerWidth / 2, t = t.getBoundingClientRect(), s = this._findFirstScrollableElement(this.parentElement)) && s.scrollTo({
          behavior: "smooth",
          left: s.scrollLeft + (t.left - e) + t.width / 2
        });
      }
      _dispatchEvent(e) {
        e !== this.selectedIndex && this.dispatchEvent(new CustomEvent("page-dots:changed", {
          bubbles: !0,
          detail: {
            index: e
          }
        }));
      }
      _findFirstScrollableElement(e, t = 0) {
        return null === e || 3 < t ? null : e.scrollWidth > e.clientWidth ? e : this._findFirstScrollableElement(e.parentElement, t + 1);
      }
    }),
    h = (window.customElements.define("page-dots", h), class extends HTMLElement {
      connectedCallback() {
        this.prevButton = this.querySelector("button:first-of-type"), this.nextButton = this.querySelector("button:last-of-type"), this.prevButton.addEventListener("click", () => this.prevButton.dispatchEvent(new CustomEvent("prev-next:prev", {
          bubbles: !0
        }))), this.nextButton.addEventListener("click", () => this.nextButton.dispatchEvent(new CustomEvent("prev-next:next", {
          bubbles: !0
        })));
      }
      set isPrevDisabled(e) {
        this.prevButton.disabled = e;
      }
      set isNextDisabled(e) {
        this.nextButton.disabled = e;
      }
    }),
    p = class extends HTMLButtonElement {
      connectedCallback() {
        this.addEventListener("click", () => this.dispatchEvent(new CustomEvent("prev-next:prev", {
          bubbles: !0
        })));
      }
    },
    m = class extends HTMLButtonElement {
      connectedCallback() {
        this.addEventListener("click", () => this.dispatchEvent(new CustomEvent("prev-next:next", {
          bubbles: !0
        })));
      }
    };
  function b() {
    var e = getComputedStyle(document.documentElement);
    return parseInt(e.getPropertyValue("--header-height") || 0) * parseInt(e.getPropertyValue("--enable-sticky-header") || 0) + parseInt(e.getPropertyValue("--announcement-bar-height") || 0) * parseInt(e.getPropertyValue("--enable-sticky-announcement-bar") || 0);
  }
  window.customElements.define("prev-next-buttons", h), window.customElements.define("prev-button", p, {
    extends: "button"
  }), window.customElements.define("next-button", m, {
    extends: "button"
  });
  h = class extends HTMLElement {
    connectedCallback() {
      this.lastKnownY = window.scrollY, this.currentTop = 0, this.hasPendingRaf = !1, window.addEventListener("scroll", this._checkPosition.bind(this));
    }
    get initialTopOffset() {
      return b() + (parseInt(this.getAttribute("offset")) || 0);
    }
    _checkPosition() {
      this.hasPendingRaf || (this.hasPendingRaf = !0, requestAnimationFrame(() => {
        var e = this.getBoundingClientRect().top + window.scrollY - this.offsetTop + this.initialTopOffset,
          t = this.clientHeight - window.innerHeight;
        window.scrollY < this.lastKnownY ? this.currentTop -= window.scrollY - this.lastKnownY : this.currentTop += this.lastKnownY - window.scrollY, this.currentTop = Math.min(Math.max(this.currentTop, -t), e, this.initialTopOffset), this.lastKnownY = window.scrollY, this.style.top = this.currentTop + "px", this.hasPendingRaf = !1;
      }));
    }
  };
  function g(t, i = 15) {
    let s = null,
      n = null,
      a = e => {
        n = e, s || (t(n), n = null, s = setTimeout(() => {
          s = null, n && a(n);
        }, i));
      };
    return a;
  }
  window.customElements.define("safe-sticky", h);
  var p = class extends HTMLElement {
      connectedCallback() {
        this._createSvg(), this.elementsToObserve = Array.from(this.querySelectorAll("a")).map(e => document.querySelector(e.getAttribute("href"))), this.navListItems = Array.from(this.querySelectorAll("li")), this.navItems = this.navListItems.map(e => {
          var t = e.firstElementChild,
            i = t && t.getAttribute("href").slice(1);
          return {
            listItem: e,
            anchor: t,
            target: document.getElementById(i)
          };
        }).filter(e => e.target), this.drawPath(), window.addEventListener("scroll", g(this.markVisibleSection.bind(this), 25)), window.addEventListener("orientationchange", () => {
          window.addEventListener("resize", () => {
            this.drawPath(), this.markVisibleSection();
          }, {
            once: !0
          });
        }), this.markVisibleSection();
      }
      _createSvg() {
        this.navPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
        var e = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        e.insertAdjacentElement("beforeend", this.navPath), this.insertAdjacentElement("beforeend", e), this.lastPathStart = this.lastPathEnd = null;
      }
      drawPath() {
        let a = [],
          r;
        this.navItems.forEach((e, t) => {
          var i = e.anchor.offsetLeft - 5,
            s = e.anchor.offsetTop,
            n = e.anchor.offsetHeight;
          0 === t ? (a.push("M", i, s, "L", i, s + n), e.pathStart = 0) : (r !== i && a.push("L", r, s), a.push("L", i, s), this.navPath.setAttribute("d", a.join(" ")), e.pathStart = this.navPath.getTotalLength() || 0, a.push("L", i, s + n)), r = i, this.navPath.setAttribute("d", a.join(" ")), e.pathEnd = this.navPath.getTotalLength();
        });
      }
      syncPath() {
        let e = () => 0 < this.querySelectorAll(".is-visible").length,
          t = this.navPath.getTotalLength(),
          i = t,
          s = 0;
        var n;
        this.navItems.forEach(e => {
          e.listItem.classList.contains("is-visible") && (i = Math.min(e.pathStart, i), s = Math.max(e.pathEnd, s));
        }), e() && i < s ? i === this.lastPathStart && s === this.lastPathEnd || (n = `1 ${i} ${s - i} ` + t, this.navPath.style.setProperty("stroke-dashoffset", "1"), this.navPath.style.setProperty("stroke-dasharray", n), this.navPath.style.setProperty("opacity", "1")) : this.navPath.style.setProperty("opacity", "0"), this.lastPathStart = i, this.lastPathEnd = s;
      }
      markVisibleSection() {
        this.navListItems.forEach(e => e.classList.remove("is-visible"));
        for (var [e, t] of this.elementsToObserve.entries()) if (t.getBoundingClientRect().top > b() || e === this.elementsToObserve.length - 1) {
          this.querySelector(`a[href="#${t.id}"]`).parentElement.classList.add("is-visible");
          break;
        }
        this.syncPath();
      }
    },
    ae = (window.customElements.define("scroll-spy", p), class {
      constructor(e) {
        this.scheduleUpdate = g(() => this.update(e, getComputedStyle(e))), this.resizeObserver = new ResizeObserver(this.scheduleUpdate.bind(this));
      }
      start(e) {
        this.element && this.stop(), e && (e.addEventListener("scroll", this.scheduleUpdate), this.resizeObserver.observe(e), this.element = e);
      }
      stop() {
        this.element && (this.element.removeEventListener("scroll", this.scheduleUpdate), this.resizeObserver.unobserve(this.element), this.element = null);
      }
      update(s, e) {
        if (this.element) {
          let t = e.getPropertyValue("--scroll-shadow-size") ? parseInt(e.getPropertyValue("--scroll-shadow-size")) : 0,
            i = {
              top: Math.max(this.element.scrollTop, 0),
              bottom: Math.max(this.element.scrollHeight - this.element.offsetHeight - this.element.scrollTop, 0),
              left: Math.max(this.element.scrollLeft, 0),
              right: Math.max(this.element.scrollWidth - this.element.offsetWidth - this.element.scrollLeft, 0)
            };
          requestAnimationFrame(() => {
            for (var e of ["top", "bottom", "left", "right"]) s.style.setProperty("--" + e, `${i[e] > t ? t : i[e]}px`);
          });
        }
      }
    }),
    m = class extends HTMLElement {
      constructor() {
        super(), this.attachShadow({
          mode: "open"
        }).innerHTML = `
  <style>
    :host {
      display: inline-block;
      contain: layout;
      position: relative;
    }
    
    :host([hidden]) {
      display: none;
    }
    
    s {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      pointer-events: none;
      background-image:
        var(--scroll-shadow-top, radial-gradient(farthest-side at 50% 0%, rgba(0,0,0,.2), rgba(0,0,0,0))),
        var(--scroll-shadow-bottom, radial-gradient(farthest-side at 50% 100%, rgba(0,0,0,.2), rgba(0,0,0,0))),
        var(--scroll-shadow-left, radial-gradient(farthest-side at 0%, rgba(0,0,0,.2), rgba(0,0,0,0))),
        var(--scroll-shadow-right, radial-gradient(farthest-side at 100%, rgba(0,0,0,.2), rgba(0,0,0,0)));
      background-position: top, bottom, left, right;
      background-repeat: no-repeat;
      background-size: 100% var(--top, 0), 100% var(--bottom, 0), var(--left, 0) 100%, var(--right, 0) 100%;
    }
  </style>
  <slot></slot>
  <s></s>
`, this.updater = new ae(this.shadowRoot.lastElementChild);
      }
      connectedCallback() {
        this.shadowRoot.querySelector("slot").addEventListener("slotchange", () => this.start()), this.start();
      }
      disconnectedCallback() {
        this.updater.stop();
      }
      start() {
        this.updater.start(this.firstElementChild);
      }
    },
    h = ("ResizeObserver" in window && window.customElements.define("scroll-shadow", m), class extends u {
      _onButtonClick() {
        window.matchMedia(window.themeVariables.breakpoints.phone).matches && navigator.share ? navigator.share({
          title: this.hasAttribute("share-title") ? this.getAttribute("share-title") : document.title,
          url: this.hasAttribute("share-url") ? this.getAttribute("share-url") : window.location.href
        }) : super._onButtonClick();
      }
    }),
    p = (window.customElements.define("share-toggle-button", h, {
      extends: "button"
    }), class extends a {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll("native-carousel-item")), this.pageDotsElements = Array.from(this.querySelectorAll("page-dots")), this.prevNextButtonsElements = Array.from(this.querySelectorAll("prev-next-buttons")), 1 < this.items.length && (this.addEventListener("prev-next:prev", this.prev.bind(this)), this.addEventListener("prev-next:next", this.next.bind(this)), this.addEventListener("page-dots:changed", e => this.select(e.detail.index, !0)), Shopify.designMode) && this.addEventListener("shopify:block:select", e => this.select(e.target.index, !e.detail.load));
        var e = this.items[0].parentElement;
        this.intersectionObserver = new IntersectionObserver(this._onVisibilityChanged.bind(this), {
          root: e,
          rootMargin: e.clientHeight + "px 0px",
          threshold: .8
        }), this.items.forEach(e => this.intersectionObserver.observe(e));
      }
      disconnectedCallback() {
        super.disconnectedCallback(), this.intersectionObserver.disconnect();
      }
      get selectedIndex() {
        return this.items.findIndex(e => e.selected);
      }
      prev(e = !0) {
        this.select(Math.max(this.selectedIndex - 1, 0), e);
      }
      next(e = !0) {
        this.select(Math.min(this.selectedIndex + 1, this.items.length - 1), e);
      }
      select(e, t = !0) {
        let i = Math.max(0, Math.min(e, this.items.length));
        var e = this.items[i],
          s = (this._adjustNavigationForElement(e), t && (this.items.forEach(e => this.intersectionObserver.unobserve(e)), setInterval(() => {
            this.items.forEach(e => this.intersectionObserver.observe(e));
          }, 800)), this.items.forEach((e, t) => e.selected = t === i), "ltr" === window.themeVariables.settings.direction ? 1 : -1);
        e.parentElement.scrollTo({
          left: s * (e.clientWidth * i),
          behavior: t ? "smooth" : "auto"
        });
      }
      _adjustNavigationForElement(t) {
        this.items.forEach(e => e.selected = t === e), this.pageDotsElements.forEach(e => e.selectedIndex = t.index), this.prevNextButtonsElements.forEach(e => {
          e.isPrevDisabled = 0 === t.index, e.isNextDisabled = t.index === this.items.length - 1;
        });
      }
      _onVisibilityChanged(e) {
        for (var t of e) if (t.isIntersecting) {
          this._adjustNavigationForElement(t.target);
          break;
        }
      }
    }),
    m = (window.customElements.define("native-carousel-item", class extends a {
      static get observedAttributes() {
        return ["hidden"];
      }
      get index() {
        return [...this.parentNode.children].indexOf(this);
      }
      get selected() {
        return !this.hasAttribute("hidden");
      }
      set selected(e) {
        this.hidden = !e;
      }
    }), window.customElements.define("native-carousel", p), class extends HTMLElement {
      connectedCallback() {
        this.scrollableElement = this.parentElement, this.scrollableElement.addEventListener("mouseenter", this._onMouseEnter.bind(this)), this.scrollableElement.addEventListener("mousemove", this._onMouseMove.bind(this)), this.scrollableElement.addEventListener("mouseleave", this._onMouseLeave.bind(this)), this.innerHTML = `
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
        <path d="M0 60C0 26.863 26.863 0 60 0s60 26.863 60 60-26.863 60-60 60S0 93.137 0 60z" fill="rgb(var(--text-color))"/>
        <path d="M46 50L36 60l10 10M74 50l10 10-10 10" stroke="rgb(var(--section-background))" stroke-width="4"/>
      </svg>
    `;
      }
      _onMouseEnter(e) {
        this.removeAttribute("hidden"), this._positionCursor(e);
      }
      _onMouseLeave() {
        this.setAttribute("hidden", "");
      }
      _onMouseMove(e) {
        this.toggleAttribute("hidden", "BUTTON" === e.target.tagName || "A" === e.target.tagName), this._positionCursor(e);
      }
      _positionCursor(e) {
        var t = this.scrollableElement.getBoundingClientRect(),
          i = e.clientX - t.x;
        this.style.transform = `translate(${i - this.clientWidth / 2}px, ${e.clientY - t.y - this.clientHeight / 2}px)`;
      }
    }),
    u = (window.customElements.define("drag-cursor", m), class extends a {
      connectedCallback() {
        this.draggable && this._setupDraggability(), this._checkScrollability(), window.addEventListener("resize", this._checkScrollability.bind(this)), this.addEventListener("scroll", g(this._calculateProgress.bind(this), 15));
      }
      get draggable() {
        return this.hasAttribute("draggable");
      }
      _setupDraggability() {
        this.insertAdjacentHTML("afterend", '<drag-cursor hidden class="custom-drag-cursor"></drag-cursor>');
        var e = matchMedia("(hover: none)");
        e.addListener(this._onMediaChanges.bind(this)), e.matches || this._attachDraggableListeners();
      }
      _attachDraggableListeners() {
        this.delegate.on("mousedown", this._onMouseDown.bind(this)), this.delegate.on("mousemove", this._onMouseMove.bind(this)), this.delegate.on("mouseup", this._onMouseUp.bind(this));
      }
      _removeDraggableListeners() {
        this.delegate.off("mousedown"), this.delegate.off("mousemove"), this.delegate.off("mouseup");
      }
      _checkScrollability() {
        this.classList.toggle("is-scrollable", this.scrollWidth > this.offsetWidth);
      }
      _calculateProgress() {
        var e = this.scrollLeft * ("ltr" === window.themeVariables.settings.direction ? 1 : -1);
        n(this, "scrollable-content:progress", {
          progress: 100 * Math.max(0, Math.min(1, e / (this.scrollWidth - this.clientWidth)))
        });
      }
      _onMediaChanges(e) {
        e.matches ? this._removeDraggableListeners() : this._attachDraggableListeners();
      }
      _onMouseDown(e) {
        e.target && "IMG" === e.target.nodeName && e.preventDefault(), this.startX = e.clientX + this.scrollLeft, this.diffX = 0, this.drag = !0;
      }
      _onMouseMove(e) {
        this.drag && (this.diffX = this.startX - (e.clientX + this.scrollLeft), this.scrollLeft += this.diffX);
      }
      _onMouseUp() {
        this.drag = !1;
        let t = 1,
          i = () => {
            var e = Math.sinh(t);
            e <= 0 ? window.cancelAnimationFrame(i) : (this.scrollLeft += this.diffX * e, t -= .03, window.requestAnimationFrame(i));
          };
        i();
      }
    }),
    h = (window.customElements.define("scrollable-content", u), class extends a {
      constructor() {
        super(), this.rootDelegate.on("theme:loading:start", this.show.bind(this)), this.rootDelegate.on("theme:loading:end", this.hide.bind(this)), this.delegate.on("transitionend", this._onTransitionEnd.bind(this));
      }
      show() {
        this.classList.add("is-visible"), this.style.transform = "scaleX(0.4)";
      }
      hide() {
        this.style.transform = "scaleX(1)", this.classList.add("is-finished");
      }
      _onTransitionEnd(e) {
        "transform" === e.propertyName && this.classList.contains("is-finished") && (this.classList.remove("is-visible"), this.classList.remove("is-finished"), this.style.transform = "scaleX(0)");
      }
    }),
    p = (window.customElements.define("loading-bar", h), class extends HTMLElement {
      connectedCallback() {
        this.originalContent = this.textContent, this.lastWidth = window.innerWidth, this.hasBeenSplitted = !1, window.addEventListener("resize", this._onResize.bind(this));
      }
      [Symbol.asyncIterator]() {
        return {
          splitPromise: this.split.bind(this),
          index: 0,
          async next() {
            var e = await this.splitPromise();
            return this.index !== e.length ? {
              done: !1,
              value: e[this.index++]
            } : {
              done: !0
            };
          }
        };
      }
      split(t = !1) {
        return 0 < this.childElementCount && !t ? Promise.resolve(Array.from(this.children)) : (this.hasBeenSplitted = !0, new Promise(e => {
          requestAnimationFrame(() => {
            this.innerHTML = this.originalContent.replace(/./g, "<span>$&</span>").replace(/\s/g, " ");
            let i = {};
            Array.from(this.children).forEach(e => {
              var t = parseInt(e.getBoundingClientRect().top);
              i[t] = (i[t] || "") + e.textContent;
            }), this.innerHTML = Object.values(i).map(e => `<span ${this.hasAttribute("reveal") && !t ? "reveal" : ""} ${this.hasAttribute("reveal-visibility") && !t ? "reveal-visibility" : ""} style="display: block">${e.trim()}</span>`).join(""), this.style.opacity = this.hasAttribute("reveal") ? 1 : null, this.style.visibility = this.hasAttribute("reveal-visibility") ? "visible" : null, e(Array.from(this.children));
          });
        }));
      }
      async _onResize() {
        this.lastWidth !== window.innerWidth && this.hasBeenSplitted && (await this.split(!0), this.dispatchEvent(new CustomEvent("split-lines:re-split", {
          bubbles: !0
        })), this.lastWidth = window.innerWidth);
      }
    }),
    m = (window.customElements.define("split-lines", p), class extends r {
      connectedCallback() {
        super.connectedCallback(), this.delegate.on("click", ".popover__overlay", () => this.open = !1);
      }
      attributeChangedCallback(e, t, i) {
        super.attributeChangedCallback(e, t, i), "open" === e && document.documentElement.classList.toggle("lock-mobile", this.open);
      }
    }),
    u = (window.customElements.define("popover-content", m), class extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll("button[aria-controls]")), this.scrollerElement = this.querySelector(".tabs-nav__scroller"), this.buttons.forEach(e => e.addEventListener("click", () => this.selectButton(e))), this.addEventListener("shopify:block:select", e => this.selectButton(e.target, !e.detail.load)), this.positionElement = document.createElement("span"), this.positionElement.classList.add("tabs-nav__position"), this.buttons[0].parentElement.insertAdjacentElement("afterend", this.positionElement), window.addEventListener("resize", this._onWindowResized.bind(this)), this._adjustNavigationPosition(), this.hasArrows && this._handleArrows();
      }
      get hasArrows() {
        return this.hasAttribute("arrows");
      }
      get selectedTabIndex() {
        return this.buttons.findIndex(e => "true" === e.getAttribute("aria-expanded"));
      }
      get selectedButton() {
        return this.buttons.find(e => "true" === e.getAttribute("aria-expanded"));
      }
      selectButton(e, t = !0) {
        var i, s;
        this.buttons.includes(e) && this.selectedButton !== e && (i = document.getElementById(this.selectedButton.getAttribute("aria-controls")), s = document.getElementById(e.getAttribute("aria-controls")), t ? this._transitionContent(i, s) : (i.hidden = !0, s.hidden = !1), this.selectedButton.setAttribute("aria-expanded", "false"), e.setAttribute("aria-expanded", "true"), n(this, "tabs-nav:changed", {
          button: e
        }), this._adjustNavigationPosition());
      }
      addButton(e) {
        e.addEventListener("click", () => this.selectButton(e)), e.setAttribute("aria-expanded", "false"), this.buttons[this.buttons.length - 1].insertAdjacentElement("afterend", e), this.buttons.push(e), this._adjustNavigationPosition(!1);
      }
      _transitionContent(e, t) {
        e.animate({
          opacity: [1, 0]
        }, {
          duration: 250,
          easing: "ease"
        }).onfinish = () => {
          e.hidden = !0, t.hidden = !1, t.animate({
            opacity: [0, 1]
          }, {
            duration: 250,
            easing: "ease"
          });
        };
      }
      _onWindowResized() {
        this._adjustNavigationPosition();
      }
      _adjustNavigationPosition(e = !0) {
        var t = this.selectedButton.clientWidth / this.positionElement.parentElement.clientWidth,
          i = this.selectedButton.offsetLeft / this.positionElement.parentElement.clientWidth / t,
          s = this.scrollerElement.clientWidth / 2;
        this.scrollerElement.scrollTo({
          behavior: e ? "smooth" : "auto",
          left: this.selectedButton.offsetLeft - s + this.selectedButton.clientWidth / 2
        }), e || (this.positionElement.style.transition = "none"), this.positionElement.style.setProperty("--scale", t), this.positionElement.style.setProperty("--translate", 100 * i + "%"), this.positionElement.clientWidth, requestAnimationFrame(() => {
          this.positionElement.classList.add("is-initialized"), this.positionElement.style.transition = null;
        });
      }
      _handleArrows() {
        var e = this.querySelector(".tabs-nav__arrows");
        e.firstElementChild.addEventListener("click", () => {
          this.selectButton(this.buttons[Math.max(this.selectedTabIndex - 1, 0)]);
        }), e.lastElementChild.addEventListener("click", () => {
          this.selectButton(this.buttons[Math.min(this.selectedTabIndex + 1, this.buttons.length - 1)]);
        });
      }
    }),
    f = (window.customElements.define("tabs-nav", u), class {
      static load(e) {
        let t = "requested",
          s = "loaded",
          n = this.libraries[e];
        if (n) {
          if (n.status === t) return n.promise;
          if (n.status === s) return Promise.resolve();
          let e;
          return e = "script" === n.type ? new Promise((e, t) => {
            var i = document.createElement("script");
            i.id = n.tagId, i.src = n.src, i.onerror = t, i.onload = () => {
              n.status = s, e();
            }, document.body.appendChild(i);
          }) : new Promise((e, t) => {
            var i = document.createElement("link");
            i.id = n.tagId, i.href = n.src, i.rel = "stylesheet", i.type = "text/css", i.onerror = t, i.onload = () => {
              n.status = s, e();
            }, document.body.appendChild(i);
          }), n.promise = e, n.status = t, e;
        }
      }
    }),
    h = (e(f, "libraries", {
      flickity: {
        tagId: "flickity",
        src: window.themeVariables.libs.flickity,
        type: "script"
      },
      photoswipe: {
        tagId: "photoswipe",
        src: window.themeVariables.libs.photoswipe,
        type: "script"
      },
      qrCode: {
        tagId: "qrCode",
        src: window.themeVariables.libs.qrCode,
        type: "script"
      },
      modelViewerUiStyles: {
        tagId: "shopify-model-viewer-ui-styles",
        src: "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
        type: "link"
      }
    }), class extends HTMLElement {
      async connectedCallback() {
        await f.load("qrCode"), new window.QRCode(this, {
          text: this.getAttribute("identifier"),
          width: 200,
          height: 200
        });
      }
    }),
    p = (window.customElements.define("qr-code", h), class extends HTMLSelectElement {
      connectedCallback() {
        if (this.provinceElement = document.getElementById(this.getAttribute("aria-owns")), this.addEventListener("change", this._updateProvinceVisibility.bind(this)), this.hasAttribute("data-default")) for (let e = 0; e !== this.options.length; ++e) if (this.options[e].text === this.getAttribute("data-default")) {
          this.selectedIndex = e;
          break;
        }
        this._updateProvinceVisibility();
        var t = "SELECT" === this.provinceElement.tagName ? this.provinceElement : this.provinceElement.querySelector("select");
        if (t.hasAttribute("data-default")) for (let e = 0; e !== t.options.length; ++e) if (t.options[e].text === t.getAttribute("data-default")) {
          t.selectedIndex = e;
          break;
        }
      }
      _updateProvinceVisibility() {
        var i = this.options[this.selectedIndex];
        if (i) {
          let e = JSON.parse(i.getAttribute("data-provinces") || "[]"),
            t = "SELECT" === this.provinceElement.tagName ? this.provinceElement : this.provinceElement.querySelector("select");
          t.innerHTML = "", 0 === e.length ? this.provinceElement.hidden = !0 : (e.forEach(e => {
            t.options.add(new Option(e[1], e[0]));
          }), this.provinceElement.hidden = !1);
        }
      }
    }),
    u = (window.customElements.define("country-selector", p, {
      extends: "select"
    }), class extends r {
      connectedCallback() {
        super.connectedCallback(), !this.appearAfterDelay || this.onlyOnce && this.hasAppearedOnce || setTimeout(() => this.open = !0, this.apparitionDelay), this.delegate.on("click", ".modal__overlay", () => this.open = !1);
      }
      get appearAfterDelay() {
        return this.hasAttribute("apparition-delay");
      }
      get apparitionDelay() {
        return 1e3 * parseInt(this.getAttribute("apparition-delay") || 0);
      }
      get onlyOnce() {
        return this.hasAttribute("only-once");
      }
      get hasAppearedOnce() {
        return null !== localStorage.getItem("theme:popup-appeared");
      }
      attributeChangedCallback(e, t, i) {
        super.attributeChangedCallback(e, t, i), "open" === e && (document.documentElement.classList.toggle("lock-all", this.open), this.open) && localStorage.setItem("theme:popup-appeared", !0);
      }
    }),
    h = (window.customElements.define("modal-content", u), class extends HTMLElement {
      connectedCallback() {
        this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child"), this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child"), this.textInputLowerBound = this.querySelector(".price-range__input:first-child input"), this.textInputHigherBound = this.querySelector(".price-range__input:last-child input"), this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select()), this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select()), this.textInputLowerBound.addEventListener("change", e => {
          e.target.value = Math.max(Math.min(parseInt(e.target.value), parseInt(this.textInputHigherBound.value || e.target.max) - 1), e.target.min), this.rangeLowerBound.value = e.target.value, this.rangeLowerBound.parentElement.style.setProperty("--range-min", parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max) * 100 + "%");
        }), this.textInputHigherBound.addEventListener("change", e => {
          e.target.value = Math.min(Math.max(parseInt(e.target.value), parseInt(this.textInputLowerBound.value || e.target.min) + 1), e.target.max), this.rangeHigherBound.value = e.target.value, this.rangeHigherBound.parentElement.style.setProperty("--range-max", parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max) * 100 + "%");
        }), this.rangeLowerBound.addEventListener("change", e => {
          this.textInputLowerBound.value = e.target.value, this.textInputLowerBound.dispatchEvent(new Event("change", {
            bubbles: !0
          }));
        }), this.rangeHigherBound.addEventListener("change", e => {
          this.textInputHigherBound.value = e.target.value, this.textInputHigherBound.dispatchEvent(new Event("change", {
            bubbles: !0
          }));
        }), this.rangeLowerBound.addEventListener("input", e => {
          n(this, "facet:abort-loading"), e.target.value = Math.min(parseInt(e.target.value), parseInt(this.textInputHigherBound.value || e.target.max) - 1), e.target.parentElement.style.setProperty("--range-min", parseInt(e.target.value) / parseInt(e.target.max) * 100 + "%"), this.textInputLowerBound.value = e.target.value;
        }), this.rangeHigherBound.addEventListener("input", e => {
          n(this, "facet:abort-loading"), e.target.value = Math.max(parseInt(e.target.value), parseInt(this.textInputLowerBound.value || e.target.min) + 1), e.target.parentElement.style.setProperty("--range-max", parseInt(e.target.value) / parseInt(e.target.max) * 100 + "%"), this.textInputHigherBound.value = e.target.value;
        });
      }
    }),
    p = (window.customElements.define("price-range", h), class extends HTMLElement {
      connectedCallback() {
        let e = this.querySelector(".link-bar__link-item--selected");
        e && requestAnimationFrame(() => {
          e.style.scrollSnapAlign = "none";
        });
      }
    }),
    v = (window.customElements.define("link-bar", p), class {
      static prefersReducedMotion() {
        return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      }
      static supportsHover() {
        return window.matchMedia("(pointer: fine)").matches;
      }
    });
  function w(e, t, i = !1) {
    var s = [];
    let n = e;
    for (; n = n.previousElementSibling;) t && !n.matches(t) || s.push(n);
    for (i && s.push(e), n = e; n = n.nextElementSibling;) t && !n.matches(t) || s.push(n);
    return s;
  }
  async function L(e) {
    var t,
      i = [];
    for (t of e = null != e && "function" == typeof e[Symbol.iterator] ? e : [e]) if ("function" == typeof t[Symbol.asyncIterator]) for await (var s of t) i.push(s);else i.push(t);
    return i;
  }
  window.customElements.define("flickity-carousel", class extends a {
    constructor() {
      super(), 1 !== this.childElementCount && (this.addEventListener("flickity:ready", this._preloadNextImage.bind(this)), this.addEventListener("flickity:slide-changed", this._preloadNextImage.bind(this)), this._createFlickity());
    }
    async disconnectedCallback() {
      this.flickity && (await this.flickity).destroy();
    }
    get flickityConfig() {
      return JSON.parse(this.getAttribute("flickity-config"));
    }
    get flickityInstance() {
      return this.flickity;
    }
    async next() {
      (await this.flickityInstance).next();
    }
    async previous() {
      (await this.flickityInstance).previous();
    }
    async select(e) {
      (await this.flickityInstance).selectCell(e);
    }
    async setDraggable(e) {
      var t = await this.flickity;
      t.options.draggable = e, t.updateDraggable();
    }
    async reload() {
      (await this.flickity).destroy(), this.flickityConfig.cellSelector && Array.from(this.children).sort((e, t) => parseInt(e.getAttribute("data-original-position")) > parseInt(t.getAttribute("data-original-position")) ? 1 : -1).forEach(e => this.appendChild(e)), this._createFlickity();
    }
    async _createFlickity() {
      this.flickity = new Promise(async e => {
        await f.load("flickity"), await this.untilVisible({
          rootMargin: "400px",
          threshold: 0
        }), e(new window.ThemeFlickity(this, {
          ...this.flickityConfig,
          rightToLeft: "rtl" === window.themeVariables.settings.direction,
          accessibility: v.supportsHover(),
          on: {
            ready: e => n(this, "flickity:ready", e),
            change: e => n(this, "flickity:slide-changed", e),
            settle: e => n(this, "flickity:slide-settled", e)
          }
        }));
      }), this.hasAttribute("click-nav") && ((await this.flickityInstance).on("staticClick", this._onStaticClick.bind(this)), this.addEventListener("mousemove", this._onMouseMove.bind(this)));
    }
    async _onStaticClick(e, t, i) {
      var s = await this.flickityInstance,
        n = s.selectedElement.hasAttribute("data-media-type") && ["video", "external_video", "model"].includes(s.selectedElement.getAttribute("data-media-type"));
      !i || n || window.matchMedia(window.themeVariables.breakpoints.phone).matches || (i = s.viewport.getBoundingClientRect(), n = Math.floor(i.right - i.width / 2), t.clientX > n ? s.next() : s.previous());
    }
    async _onMouseMove(e) {
      var t = await this.flickityInstance,
        t = t.selectedElement.hasAttribute("data-media-type") && ["video", "external_video", "model"].includes(t.selectedElement.getAttribute("data-media-type"));
      this.classList.toggle("is-hovering-right", e.offsetX > this.clientWidth / 2 && !t), this.classList.toggle("is-hovering-left", e.offsetX <= this.clientWidth / 2 && !t);
    }
    async _preloadNextImage() {
      var e = await this.flickity;
      e.selectedElement.nextElementSibling && null != (e = e.selectedElement.nextElementSibling.querySelector("img")) && e.setAttribute("loading", "eager");
    }
  });
  window.customElements.define("flickity-controls", class extends a {
    async connectedCallback() {
      this.flickityCarousel.addEventListener("flickity:ready", this._onSlideChanged.bind(this, !1)), this.flickityCarousel.addEventListener("flickity:slide-changed", this._onSlideChanged.bind(this, !0)), this.delegate.on("click", '[data-action="prev"]', () => this.flickityCarousel.previous()), this.delegate.on("click", '[data-action="next"]', () => this.flickityCarousel.next()), this.delegate.on("click", '[data-action="select"]', (e, t) => this.flickityCarousel.select("#" + t.getAttribute("aria-controls")));
    }
    get flickityCarousel() {
      return this._flickityCarousel = this._flickityCarousel || document.getElementById(this.getAttribute("controls"));
    }
    async _onSlideChanged(s = !0) {
      var e = await this.flickityCarousel.flickityInstance;
      Array.from(this.querySelectorAll(`[aria-controls="${e.selectedElement.id}"]`)).forEach(i => {
        i.setAttribute("aria-current", "true"), w(i).forEach(e => e.removeAttribute("aria-current")), requestAnimationFrame(() => {
          var e, t;
          (() => {
            const box = i.closest('.product__thumbnail-list');
            if (box && this.closest('product-media')) {
              if (!i.offsetParent) return;
              const r = i.getBoundingClientRect(),
                b = box.getBoundingClientRect();
              box.scrollTo({
                behavior: s ? 'smooth' : 'auto',
                top: box.scrollTop + r.top - b.top - (box.clientHeight - r.height) / 2,
                left: box.scrollLeft + r.left - b.left - (box.clientWidth - r.width) / 2
              });
              return;
            }
            i.offsetParent && i.offsetParent !== this && (e = i.offsetParent.clientHeight / 2, t = i.offsetParent.clientWidth / 2, i.offsetParent.scrollTo({
              behavior: s ? 'smooth' : 'auto',
              top: i.offsetTop - e + i.clientHeight / 2,
              left: i.offsetLeft - t + i.clientWidth / 2
            }));
          })();
        });
      });
    }
  });
  var u = class extends a {
      constructor() {
        super(), this.hasLoaded = !1, (async () => {
          this.autoPlay ? (await this.untilVisible({
            rootMargin: "300px",
            threshold: 0
          }), this.play()) : this.addEventListener("click", this.play.bind(this), {
            once: !0
          });
        })();
      }
      get autoPlay() {
        return this.hasAttribute("autoplay");
      }
      get provider() {
        return this.getAttribute("provider");
      }
      async play() {
        this.hasLoaded || (await this._setupPlayer()), "youtube" === this.provider ? setTimeout(() => {
          this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({
            event: "command",
            func: "playVideo",
            args: ""
          }), "*");
        }, 150) : "vimeo" === this.provider && this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({
          method: "play"
        }), "*");
      }
      pause() {
        this.hasLoaded && ("youtube" === this.provider ? this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({
          event: "command",
          func: "pauseVideo",
          args: ""
        }), "*") : "vimeo" === this.provider && this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({
          method: "pause"
        }), "*"));
      }
      _setupPlayer() {
        return this._setupPromise || (this._setupPromise = new Promise(e => {
          var t = this.querySelector("template"),
            i = t.content.firstElementChild.cloneNode(!0);
          i.onload = () => {
            this.hasLoaded = !0, e();
          }, this.autoPlay ? t.replaceWith(i) : (this.innerHTML = "", this.appendChild(i));
        }));
      }
    },
    A = (window.customElements.define("external-video", u), class {
      static load(t) {
        if (t) return this.loadedProducts[t] || (this.loadedProducts[t] = new Promise(async e => {
          e(await (await fetch(window.themeVariables.routes.rootUrlWithoutSlash + `/products/${t}.js`)).json());
        })), this.loadedProducts[t];
      }
    }),
    h = (e(A, "loadedProducts", {}), class extends HTMLElement {
      constructor() {
        super(), f.load("modelViewerUiStyles"), window.Shopify.loadFeatures([{
          name: "shopify-xr",
          version: "1.0",
          onLoad: this._setupShopifyXr.bind(this)
        }, {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: () => {
            this.modelUi = new window.Shopify.ModelViewerUI(this.firstElementChild, {
              focusOnPlay: !1
            });
            let e = this.querySelector("model-viewer");
            e.addEventListener("shopify_model_viewer_ui_toggle_play", () => {
              e.dispatchEvent(new CustomEvent("model:played", {
                bubbles: !0
              }));
            }), e.addEventListener("shopify_model_viewer_ui_toggle_pause", () => {
              e.dispatchEvent(new CustomEvent("model:paused", {
                bubbles: !0
              }));
            });
          }
        }]);
      }
      disconnectedCallback() {
        var e;
        null != (e = this.modelUi) && e.destroy();
      }
      play() {
        this.modelUi && this.modelUi.play();
      }
      pause() {
        this.modelUi && this.modelUi.pause();
      }
      async _setupShopifyXr() {
        var e;
        window.ShopifyXR ? (e = (await A.load(this.getAttribute("product-handle"))).media.filter(e => "model" === e.media_type), window.ShopifyXR.addModels(e), window.ShopifyXR.setupXRElements()) : document.addEventListener("shopify_xr_initialized", this._setupShopifyXr.bind(this));
      }
    }),
    p = (window.customElements.define("model-media", h), class extends HTMLElement {
      constructor() {
        super(), this.hasLoaded = !1, this.autoPlay ? this.play() : this.addEventListener("click", this.play.bind(this), {
          once: !0
        });
      }
      get autoPlay() {
        return this.hasAttribute("autoplay");
      }
      play() {
        this.hasLoaded || this._replaceContent(), this.querySelector("video").play();
      }
      pause() {
        this.hasLoaded && this.querySelector("video").pause();
      }
      _replaceContent() {
        let e = this.querySelector("template");
        e && (e = e.content.firstElementChild.cloneNode(!0), this.hasAttribute("autoplay") || (this.innerHTML = ""), this.appendChild(e), this.firstElementChild.addEventListener("play", () => {
          this.dispatchEvent(new CustomEvent("video:played", {
            bubbles: !0
          }));
        }), this.firstElementChild.addEventListener("pause", () => {
          this.dispatchEvent(new CustomEvent("video:paused", {
            bubbles: !0
          }));
        }), this.hasLoaded = !0);
      }
    }),
    u = (window.customElements.define("native-video", p), class extends r {
      connectedCallback() {
        var e, t;
        super.connectedCallback(), this.options = Array.from(this.querySelectorAll('[role="option"]')), this.delegate.on("click", '[role="option"]', this._onValueClicked.bind(this)), this.delegate.on("keydown", '[role="listbox"]', this._onKeyDown.bind(this)), this.delegate.on("change", "select", this._onValueChanged.bind(this)), this.delegate.on("click", ".combo-box__overlay", () => this.open = !1), this.hasAttribute("fit-toggle") && (e = Math.max(...this.options.map(e => e.clientWidth)), t = document.querySelector(`[aria-controls="${this.id}"]`)) && t.style.setProperty("--largest-option-width", e + 2 + "px");
      }
      get nativeSelect() {
        return this.querySelector("select");
      }
      set selectedValue(t) {
        this.options.forEach(e => {
          e.setAttribute("aria-selected", e.getAttribute("value") === t ? "true" : "false");
        });
      }
      attributeChangedCallback(e, t, i) {
        super.attributeChangedCallback(e, t, i), "open" === e && (this.open ? (t = this.getBoundingClientRect(), this.classList.toggle("combo-box--top", t.top >= window.innerHeight / 2 * 1.5), setTimeout(() => this.focusTrap.activate(), 150)) : (this.focusTrap.deactivate(), setTimeout(() => this.classList.remove("combo-box--top"), 200)), document.documentElement.classList.toggle("lock-mobile", this.open));
      }
      _onValueClicked(e, t) {
        this.selectedValue = t.value, this.nativeSelect.value = t.value, this.nativeSelect.dispatchEvent(new Event("change", {
          bubbles: !0
        })), this.open = !1;
      }
      _onValueChanged(e, t) {
        Array.from(this.nativeSelect.options).forEach(e => e.toggleAttribute("selected", t.value === e.value)), this.selectedValue = t.value;
      }
      _onKeyDown(e) {
        "ArrowDown" !== e.key && "ArrowUp" !== e.key || (e.preventDefault(), "ArrowDown" === e.key ? null != (e = document.activeElement.nextElementSibling) && e.focus() : null != (e = document.activeElement.previousElementSibling) && e.focus());
      }
    }),
    h = (window.customElements.define("combo-box", u), class extends a {
      connectedCallback() {
        this.inputElement = this.querySelector("input"), this.delegate.on("click", "button:first-child", () => this.inputElement.quantity = this.inputElement.quantity - 1), this.delegate.on("click", "button:last-child", () => this.inputElement.quantity = this.inputElement.quantity + 1);
      }
    }),
    p = (window.customElements.define("quantity-selector", h), class extends HTMLInputElement {
      connectedCallback() {
        this.addEventListener("input", this._onValueInput.bind(this)), this.addEventListener("change", this._onValueChanged.bind(this)), this.addEventListener("keydown", this._onKeyDown.bind(this));
      }
      get quantity() {
        return parseInt(this.value);
      }
      set quantity(e) {
        var t = ("number" == typeof e || "string" == typeof e && "" !== e.trim()) && !isNaN(e);
        "" !== e && ((!t || e < 0) && (e = parseInt(e) || 1), this.value = Math.max(this.min || 1, Math.min(e, this.max || Number.MAX_VALUE)).toString(), this.size = Math.max(this.value.length + 1, 2));
      }
      _onValueInput() {
        this.quantity = this.value;
      }
      _onValueChanged() {
        "" === this.value && (this.quantity = 1);
      }
      _onKeyDown(e) {
        e.stopPropagation(), "ArrowUp" === e.key ? this.quantity = this.quantity + 1 : "ArrowDown" === e.key && (this.quantity = this.quantity - 1);
      }
    }),
    u = (window.customElements.define("input-number", p, {
      extends: "input"
    }), class extends a {
      async connectedCallback() {
        await customElements.whenDefined("announcement-bar-item"), this.items = Array.from(this.querySelectorAll("announcement-bar-item")), this.hasPendingTransition = !1, this.delegate.on("click", '[data-action="prev"]', this.previous.bind(this)), this.delegate.on("click", '[data-action="next"]', this.next.bind(this)), this.autoPlay && (this.delegate.on("announcement-bar:content:open", this._pausePlayer.bind(this)), this.delegate.on("announcement-bar:content:close", this._startPlayer.bind(this))), window.ResizeObserver && (this.resizeObserver = new ResizeObserver(this._updateCustomProperties.bind(this)), this.resizeObserver.observe(this)), this.autoPlay && this._startPlayer(), Shopify.designMode && this.delegate.on("shopify:block:select", e => this.select(e.target.index, !1));
      }
      get autoPlay() {
        return this.hasAttribute("auto-play");
      }
      get selectedIndex() {
        return this.items.findIndex(e => e.selected);
      }
      previous() {
        this.select((this.selectedIndex - 1 + this.items.length) % this.items.length);
      }
      next() {
        this.select((this.selectedIndex + 1 + this.items.length) % this.items.length);
      }
      async select(e, t = !0) {
        this.selectedIndex === e || this.hasPendingTransition || (this.autoPlay && this._pausePlayer(), this.hasPendingTransition = !0, await this.items[this.selectedIndex].deselect(t), await this.items[e].select(t), this.hasPendingTransition = !1, this.autoPlay && this._startPlayer());
      }
      _pausePlayer() {
        clearInterval(this._interval);
      }
      _startPlayer() {
        clearInterval(this._interval), this._interval = setInterval(this.next.bind(this), 1e3 * parseInt(this.getAttribute("cycle-speed")));
      }
      _updateCustomProperties(e) {
        e.forEach(e => {
          e.target === this && (e = e.borderBoxSize ? (0 < e.borderBoxSize.length ? e.borderBoxSize[0] : e.borderBoxSize).blockSize : e.target.clientHeight, document.documentElement.style.setProperty("--announcement-bar-height", e + "px"));
        });
      }
    }),
    h = (window.customElements.define("announcement-bar", u), class extends a {
      connectedCallback() {
        this.hasContent && (this.contentElement = this.querySelector(".announcement-bar__content"), this.delegate.on("click", '[data-action="open-content"]', this.openContent.bind(this)), this.delegate.on("click", '[data-action="close-content"]', this.closeContent.bind(this)), Shopify.designMode) && (this.addEventListener("shopify:block:select", this.openContent.bind(this)), this.addEventListener("shopify:block:deselect", this.closeContent.bind(this)));
      }
      get index() {
        return [...this.parentNode.children].indexOf(this);
      }
      get hasContent() {
        return this.hasAttribute("has-content");
      }
      get selected() {
        return !this.hasAttribute("hidden");
      }
      get focusTrap() {
        return this._trapFocus = this._trapFocus || se(this.contentElement.querySelector(".announcement-bar__content-inner"), {
          fallbackFocus: this,
          clickOutsideDeactivates: e => !("BUTTON" === e.target.tagName),
          allowOutsideClick: e => "BUTTON" === e.target.tagName,
          onDeactivate: this.closeContent.bind(this),
          preventScroll: !0
        });
      }
      async select(t = !0) {
        this.removeAttribute("hidden"), await new Promise(e => {
          this.animate({
            transform: ["translateY(8px)", "translateY(0)"],
            opacity: [0, 1]
          }, {
            duration: t ? 150 : 0,
            easing: "ease-in-out"
          }).onfinish = e;
        });
      }
      async deselect(t = !0) {
        await this.closeContent(), await new Promise(e => {
          this.animate({
            transform: ["translateY(0)", "translateY(-8px)"],
            opacity: [1, 0]
          }, {
            duration: t ? 150 : 0,
            easing: "ease-in-out"
          }).onfinish = e;
        }), this.setAttribute("hidden", "");
      }
      async openContent() {
        this.hasContent && (this.contentElement.addEventListener("transitionend", () => this.focusTrap.activate(), {
          once: !0
        }), this.contentElement.removeAttribute("hidden"), document.documentElement.classList.add("lock-all"), this.dispatchEvent(new CustomEvent("announcement-bar:content:open", {
          bubbles: !0
        })));
      }
      async closeContent() {
        if (!this.hasContent || this.contentElement.hasAttribute("hidden")) return Promise.resolve();
        await new Promise(e => {
          this.contentElement.addEventListener("transitionend", () => e(), {
            once: !0
          }), this.contentElement.setAttribute("hidden", ""), this.focusTrap.deactivate(), document.documentElement.classList.remove("lock-all"), this.dispatchEvent(new CustomEvent("announcement-bar:content:close", {
            bubbles: !0
          }));
        });
      }
    }),
    p = (window.customElements.define("announcement-bar-item", h), class extends HTMLElement {
      connectedCallback() {
        this.facetToolbar = document.getElementById("mobile-facet-toolbar"), this.tabsNav = document.getElementById("search-tabs-nav"), this.tabsNav.addEventListener("tabs-nav:changed", this._onCategoryChanged.bind(this)), this._completeSearch();
      }
      get terms() {
        return this.getAttribute("terms");
      }
      get completeFor() {
        return this.getAttribute("complete-for").split(",");
      }
      async _completeSearch() {
        let t = [];
        this.completeFor.forEach(e => {
          t.push(fetch(`${window.themeVariables.routes.searchUrl}?section_id=${this.getAttribute("section-id")}&q=${this.terms}&type=${e}&options[prefix]=last&options[unavailable_products]=` + window.themeVariables.settings.searchUnavailableProducts));
        });
        var e = await Promise.all(t);
        await Promise.all(e.map(async e => {
          var t = document.createElement("div"),
            e = (t.innerHTML = await e.text(), t.querySelector(".main-search__category-result")),
            t = t.querySelector("#search-tabs-nav .tabs-nav__item");
          e && (e.setAttribute("hidden", ""), this.insertAdjacentElement("beforeend", e), this.tabsNav.addButton(t));
        }));
      }
      _onCategoryChanged(e) {
        e = e.detail.button;
        this.facetToolbar.classList.toggle("is-collapsed", "product" !== e.getAttribute("data-type"));
      }
    }),
    u = (window.customElements.define("search-page", p), class extends a {
      connectedCallback() {
        window.Shopify && window.Shopify.designMode && (this.rootDelegate.on("shopify:section:select", e => c(e, this, () => this.open = !0)), this.rootDelegate.on("shopify:section:deselect", e => c(e, this, () => this.open = !1))), this.delegate.on("click", '[data-action~="accept-policy"]', this._acceptPolicy.bind(this)), this.delegate.on("click", '[data-action~="decline-policy"]', this._declinePolicy.bind(this)), window.Shopify.loadFeatures([{
          name: "consent-tracking-api",
          version: "0.1",
          onLoad: this._onCookieBarSetup.bind(this)
        }]);
      }
      set open(e) {
        this.toggleAttribute("hidden", !e);
      }
      _onCookieBarSetup() {
        window.Shopify.customerPrivacy.shouldShowGDPRBanner() && (this.open = !0);
      }
      _acceptPolicy() {
        window.Shopify.customerPrivacy.setTrackingConsent(!0, () => this.open = !1);
      }
      _declinePolicy() {
        window.Shopify.customerPrivacy.setTrackingConsent(!1, () => this.open = !1);
      }
    }),
    h = (window.customElements.define("cookie-bar", u), class extends HTMLElement {
      async connectedCallback() {
        var e = await fetch(`${window.themeVariables.routes.productRecommendationsUrl}?product_id=${this.productId}&limit=${this.recommendationsCount}&section_id=${this.sectionId}&intent=` + this.intent),
          t = document.createElement("div"),
          e = (t.innerHTML = await e.text(), t.querySelector("product-recommendations"));
        e.hasChildNodes() ? this.innerHTML = e.innerHTML : "complementary" === this.intent && this.remove();
      }
      get productId() {
        return this.getAttribute("product-id");
      }
      get sectionId() {
        return this.getAttribute("section-id");
      }
      get recommendationsCount() {
        return parseInt(this.getAttribute("recommendations-count") || 4);
      }
      get intent() {
        return this.getAttribute("intent");
      }
    }),
    p = (window.customElements.define("product-recommendations", h), class extends HTMLElement {
      async connectedCallback() {
        var e, t;
        "" !== this.searchQueryString && (t = await fetch(`${window.themeVariables.routes.searchUrl}?type=product&q=${this.searchQueryString}&section_id=` + this.sectionId), (e = document.createElement("div")).innerHTML = await t.text(), (t = e.querySelector("recently-viewed-products")).hasChildNodes()) && (this.innerHTML = t.innerHTML);
      }
      get searchQueryString() {
        var e = JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]");
        return this.hasAttribute("exclude-product-id") && e.includes(parseInt(this.getAttribute("exclude-product-id"))) && e.splice(e.indexOf(parseInt(this.getAttribute("exclude-product-id"))), 1), e.map(e => "id:" + e).slice(0, this.productsCount).join(" OR ");
      }
      get sectionId() {
        return this.getAttribute("section-id");
      }
      get productsCount() {
        return this.getAttribute("products-count") || 4;
      }
    });
  function k(e, t) {
    var i,
      e = "string" == typeof e ? e : e.preview_image ? e.preview_image.src : e.url;
    return null === t ? e : "master" === t ? e.replace(/http(s)?:/, "") : (i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i)) ? (e = e.split(i[0]), i = i[0], (e[0] + "_" + t + i).replace(/http(s)?:/, "")) : null;
  }
  function C(t, e) {
    let i = [],
      s = "string" == typeof t ? e : re(t, e);
    return s.forEach(e => {
      i.push(k(t, e + "x") + ` ${e}w`);
    }), i.join(",");
  }
  function re(e, t) {
    let i = [],
      s = e.preview_image.width;
    return t.forEach(e => {
      s >= e && i.push(e);
    }), i;
  }
  function I(t) {
    return new Promise(e => {
      !t || "IMG" !== t.tagName || t.complete ? e() : t.onload = () => e();
    });
  }
  window.customElements.define("recently-viewed-products", p);
  var T = class {
      constructor(e) {
        this._effect = e, this._playState = "idle", this._finished = Promise.resolve();
      }
      get finished() {
        return this._finished;
      }
      get animationEffects() {
        return this._effect instanceof P ? [this._effect] : this._effect.animationEffects;
      }
      cancel() {
        this.animationEffects.forEach(e => e.cancel());
      }
      finish() {
        this.animationEffects.forEach(e => e.finish());
      }
      play() {
        this._playState = "running", this._effect.play(), this._finished = this._effect.finished, this._finished.then(() => {
          this._playState = "finished";
        }, e => {
          this._playState = "idle";
        });
      }
    },
    P = class {
      constructor(e, t, i = {}) {
        e && ("Animation" in window ? this._animation = new Animation(new KeyframeEffect(e, t, i)) : (i.fill = "forwards", this._animation = e.animate(t, i), this._animation.pause()), this._animation.addEventListener("finish", () => {
          e.style.opacity = t.hasOwnProperty("opacity") ? t.opacity[t.opacity.length - 1] : null, e.style.visibility = t.hasOwnProperty("visibility") ? t.visibility[t.visibility.length - 1] : null;
        }));
      }
      get finished() {
        return this._animation ? this._animation.finished || new Promise(e => this._animation.onfinish = e) : Promise.resolve();
      }
      play() {
        this._animation && (this._animation.startTime = null, this._animation.play());
      }
      cancel() {
        this._animation && this._animation.cancel();
      }
      finish() {
        this._animation && this._animation.finish();
      }
    },
    u = class {
      constructor(e) {
        this._childrenEffects = e, this._finished = Promise.resolve();
      }
      get finished() {
        return this._finished;
      }
      get animationEffects() {
        return this._childrenEffects.flatMap(e => e instanceof P ? e : e.animationEffects);
      }
    },
    M = class extends u {
      play() {
        var e,
          t = [];
        for (e of this._childrenEffects) e.play(), t.push(e.finished);
        this._finished = Promise.all(t);
      }
    },
    q = class extends u {
      play() {
        this._finished = new Promise(async (e, t) => {
          try {
            for (var i of this._childrenEffects) i.play(), await i.finished;
            e();
          } catch (e) {
            t();
          }
        });
      }
    },
    h = class extends HTMLElement {
      async connectedCallback() {
        this._pendingAnimations = [], this.addEventListener("split-lines:re-split", e => {
          Array.from(e.target.children).forEach(e => e.style.visibility = this.selected ? "visible" : "hidden");
        }), v.prefersReducedMotion() && (this.setAttribute("reveal-visibility", ""), Array.from(this.querySelectorAll("[reveal], [reveal-visibility]")).forEach(e => {
          e.removeAttribute("reveal"), e.removeAttribute("reveal-visibility");
        }));
      }
      get index() {
        return [...this.parentNode.children].indexOf(this);
      }
      get selected() {
        return !this.hasAttribute("hidden");
      }
      async transitionToLeave(e, t = !0) {
        "reveal" !== e && this.setAttribute("hidden", ""), this._pendingAnimations.forEach(e => e.cancel()), this._pendingAnimations = [];
        let i = null,
          s = await L(this.querySelectorAll("split-lines, .button-group, .button-wrapper")),
          n = Array.from(this.querySelectorAll(".slideshow__image-wrapper"));
        switch (e) {
          case "sweep":
            i = new T(new q([new P(this, {
              visibility: ["visible", "hidden"]
            }, {
              duration: 500
            }), new M(s.map(e => new P(e, {
              opacity: [1, 0],
              visibility: ["visible", "hidden"]
            })))]));
            break;
          case "fade":
            i = new T(new P(this, {
              opacity: [1, 0],
              visibility: ["visible", "hidden"]
            }, {
              duration: 250,
              easing: "ease-in-out"
            }));
            break;
          case "reveal":
            i = new T(new q([new M(s.reverse().map(e => new P(e, {
              opacity: [1, 0],
              visibility: ["visible", "hidden"]
            }, {
              duration: 250,
              easing: "ease-in-out"
            }))), new M(n.map(e => e.classList.contains("slideshow__image-wrapper--secondary") ? new P(e, {
              visibility: ["visible", "hidden"],
              clipPath: ["inset(0 0 0 0)", "inset(100% 0 0 0)"]
            }, {
              duration: 450,
              easing: "cubic-bezier(0.99, 0.01, 0.50, 0.94)"
            }) : new P(e, {
              visibility: ["visible", "hidden"],
              clipPath: ["inset(0 0 0 0)", "inset(0 0 100% 0)"]
            }, {
              duration: 450,
              easing: "cubic-bezier(0.99, 0.01, 0.50, 0.94)"
            })))]));
        }
        await this._executeAnimation(i, t), "reveal" === e && this.setAttribute("hidden", "");
      }
      async transitionToEnter(e, t = !0, i = !1) {
        this.removeAttribute("hidden"), await this._untilReady();
        let s = null,
          n = await L(this.querySelectorAll("split-lines, .button-group, .button-wrapper")),
          a = Array.from(this.querySelectorAll(".slideshow__image-wrapper"));
        switch (e) {
          case "sweep":
            s = new T(new q([new P(this, {
              visibility: ["hidden", "visible"],
              clipPath: i ? ["inset(0 100% 0 0)", "inset(0 0 0 0)"] : ["inset(0 0 0 100%)", "inset(0 0 0 0)"]
            }, {
              duration: 500,
              easing: "cubic-bezier(1, 0, 0, 1)"
            }), new M(n.map((e, t) => new P(e, {
              opacity: [0, 1],
              visibility: ["hidden", "visible"],
              clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"],
              transform: ["translateY(100%)", "translateY(0)"]
            }, {
              duration: 450,
              delay: 100 * t,
              easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
            })))]));
            break;
          case "fade":
            s = new T(new P(this, {
              opacity: [0, 1],
              visibility: ["hidden", "visible"]
            }, {
              duration: 250,
              easing: "ease-in-out"
            }));
            break;
          case "reveal":
            s = new T(new q([new M(a.map(e => e.classList.contains("slideshow__image-wrapper--secondary") ? new P(e, {
              visibility: ["hidden", "visible"],
              clipPath: ["inset(100% 0 0 0)", "inset(0 0 0 0)"]
            }, {
              duration: 450,
              delay: 100,
              easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
            }) : new P(e, {
              visibility: ["hidden", "visible"],
              clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"]
            }, {
              duration: 450,
              delay: 100,
              easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
            }))), new M(n.map((e, t) => new P(e, {
              opacity: [0, 1],
              visibility: ["hidden", "visible"],
              clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"],
              transform: ["translateY(100%)", "translateY(0)"]
            }, {
              duration: 450,
              delay: 100 * t,
              easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
            })))]));
        }
        return this._executeAnimation(s, t);
      }
      async _executeAnimation(e, t) {
        return this._pendingAnimations.push(e), t ? e.play() : e.finish(), e.finished;
      }
      async _untilReady() {
        return Promise.all(this._getVisibleImages().map(e => I(e)));
      }
      _preloadImages() {
        this._getVisibleImages().forEach(e => {
          e.setAttribute("loading", "eager");
        });
      }
      _getVisibleImages() {
        return Array.from(this.querySelectorAll("img")).filter(e => "none" !== getComputedStyle(e.parentElement).display);
      }
    },
    p = (window.customElements.define("slide-show-item", h), {
      _blockVerticalScroll(i = 18) {
        this.addEventListener("touchstart", e => {
          this.firstTouchClientX = e.touches[0].clientX;
        }), this.addEventListener("touchmove", e => {
          var t = e.touches[0].clientX - this.firstTouchClientX;
          Math.abs(t) > i && e.preventDefault();
        }, {
          passive: !1
        });
      }
    }),
    u = class extends a {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll("slide-show-item")), this.pageDots = this.querySelector("page-dots"), this.isTransitioning = !1, 1 < this.items.length && (Shopify.designMode && (this.addEventListener("shopify:block:deselect", this.startPlayer.bind(this)), this.addEventListener("shopify:block:select", e => {
          this.pausePlayer(), this.intersectionObserver.disconnect(), !e.detail.load && e.target.selected || this.select(e.target.index, !e.detail.load);
        })), this.addEventListener("swiperight", this.previous.bind(this)), this.addEventListener("swipeleft", this.next.bind(this)), this.addEventListener("page-dots:changed", e => this.select(e.detail.index)), this._blockVerticalScroll()), this._setupVisibility();
      }
      get selectedIndex() {
        return this.items.findIndex(e => e.selected);
      }
      get transitionType() {
        return v.prefersReducedMotion() ? "fade" : this.getAttribute("transition-type");
      }
      async _setupVisibility() {
        await this.untilVisible(), await this.items[this.selectedIndex].transitionToEnter(this.transitionType).catch(e => {}), this.startPlayer();
      }
      previous() {
        this.select((this.selectedIndex - 1 + this.items.length) % this.items.length, !0, !0);
      }
      next() {
        this.select((this.selectedIndex + 1 + this.items.length) % this.items.length, !0, !1);
      }
      async select(e, t = !0, i = !1) {
        var s;
        "reveal" === this.transitionType && this.isTransitioning || (this.isTransitioning = !0, s = this.items[this.selectedIndex], e = this.items[e], this.items[(e.index + 1) % this.items.length]._preloadImages(), s && s !== e && ("reveal" !== this.transitionType ? s.transitionToLeave(this.transitionType, t) : await s.transitionToLeave(this.transitionType, t)), this.pageDots && (this.pageDots.selectedIndex = e.index), await e.transitionToEnter(this.transitionType, t, i).catch(e => {}), this.isTransitioning = !1);
      }
      pausePlayer() {
        this.style.setProperty("--section-animation-play-state", "paused");
      }
      startPlayer() {
        this.hasAttribute("auto-play") && this.style.setProperty("--section-animation-play-state", "running");
      }
    },
    h = (Object.assign(u.prototype, p), window.customElements.define("slide-show", u), class extends HTMLElement {
      get index() {
        return [...this.parentNode.children].indexOf(this);
      }
      get selected() {
        return !this.hasAttribute("hidden");
      }
      get hasAttachedImage() {
        return this.hasAttribute("attached-image");
      }
      async transitionToEnter(e = !0) {
        this.removeAttribute("hidden");
        var t = this.querySelector(".image-with-text__text-wrapper"),
          i = await L(this.querySelectorAll(".image-with-text__content split-lines")),
          i = new T(new q([new M(i.map((e, t) => new P(e, {
            opacity: [0, .2, 1],
            transform: ["translateY(100%)", "translateY(0)"],
            clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"]
          }, {
            duration: 350,
            delay: 120 * t,
            easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
          }))), new P(t, {
            opacity: [0, 1]
          }, {
            duration: 300
          })]));
        return e ? i.play() : i.finish(), i.finished;
      }
      async transitionToLeave(e = !0) {
        var t = await L(this.querySelectorAll(".image-with-text__text-wrapper, .image-with-text__content split-lines")),
          t = new T(new M(t.map(e => new P(e, {
            opacity: [1, 0]
          }, {
            duration: 200
          }))));
        e ? t.play() : t.finish(), await t.finished, this.setAttribute("hidden", "");
      }
    }),
    u = (window.customElements.define("image-with-text-item", h), class extends a {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll("image-with-text-item")), this.imageItems = Array.from(this.querySelectorAll(".image-with-text__image")), this.pageDots = this.querySelector("page-dots"), this.hasPendingTransition = !1, 1 < this.items.length && (this.addEventListener("page-dots:changed", e => this.select(e.detail.index)), Shopify.designMode) && (this.addEventListener("shopify:block:deselect", this.startPlayer.bind(this)), this.addEventListener("shopify:block:select", e => {
          this.intersectionObserver.disconnect(), this.pausePlayer(), this.select(e.target.index, !e.detail.load);
        })), this._setupVisibility();
      }
      async _setupVisibility() {
        await this.untilVisible(), this.hasAttribute("reveal-on-scroll") && (await this.transitionImage(this.selectedIndex), this.select(this.selectedIndex)), this.startPlayer();
      }
      get selectedIndex() {
        return this.items.findIndex(e => e.selected);
      }
      async select(e, t = !0) {
        this.hasPendingTransition || (this.hasPendingTransition = !0, !this.items[e].hasAttachedImage && t || (await this.transitionImage(e, t)), this.selectedIndex !== e && (await this.items[this.selectedIndex].transitionToLeave(t)), this.pageDots && (this.pageDots.selectedIndex = e), await this.items[e].transitionToEnter(t), this.hasPendingTransition = !1);
      }
      async transitionImage(t, e = !0) {
        var i = this.imageItems.find(e => !e.hasAttribute("hidden")),
          s = this.imageItems.find(e => e.id === this.items[t].getAttribute("attached-image")) || i,
          i = (i.setAttribute("hidden", ""), s.removeAttribute("hidden"), await I(s), new T(new P(s, {
            visibility: ["hidden", "visible"],
            clipPath: ["inset(0 0 0 100%)", "inset(0 0 0 0)"]
          }, {
            duration: 600,
            easing: "cubic-bezier(1, 0, 0, 1)"
          })));
        e ? i.play() : i.finish();
      }
      pausePlayer() {
        this.style.setProperty("--section-animation-play-state", "paused");
      }
      startPlayer() {
        this.style.setProperty("--section-animation-play-state", "running");
      }
    }),
    h = (window.customElements.define("image-with-text", u), class extends a {
      connectedCallback() {
        this.addEventListener("split-lines:re-split", e => {
          Array.from(e.target.children).forEach(e => e.style.visibility = this.selected ? "visible" : "hidden");
        });
      }
      get index() {
        return [...this.parentNode.children].indexOf(this);
      }
      get selected() {
        return !this.hasAttribute("hidden");
      }
      async transitionToLeave(e = !0) {
        var t = await L(this.querySelectorAll("split-lines, .testimonial__author")),
          t = new T(new M(t.reverse().map((e, t) => new P(e, {
            visibility: ["visible", "hidden"],
            clipPath: ["inset(0 0 0 0)", "inset(0 0 100% 0)"],
            transform: ["translateY(0)", "translateY(100%)"]
          }, {
            duration: 350,
            delay: 60 * t,
            easing: "cubic-bezier(0.68, 0.00, 0.77, 0.00)"
          }))));
        e ? t.play() : t.finish(), await t.finished, this.setAttribute("hidden", "");
      }
      async transitionToEnter(e = !0) {
        var t = await L(this.querySelectorAll("split-lines, .testimonial__author")),
          t = new T(new M(t.map((e, t) => new P(e, {
            visibility: ["hidden", "visible"],
            clipPath: ["inset(0 0 100% 0)", "inset(0 0 0px 0)"],
            transform: ["translateY(100%)", "translateY(0)"]
          }, {
            duration: 550,
            delay: 120 * t,
            easing: "cubic-bezier(0.23, 1, 0.32, 1)"
          }))));
        return this.removeAttribute("hidden"), e ? t.play() : t.finish(), t.finished;
      }
    }),
    u = (window.customElements.define("testimonial-item", h), class extends a {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll("testimonial-item")), this.pageDots = this.querySelector("page-dots"), this.hasPendingTransition = !1, 1 < this.items.length && (this.addEventListener("swiperight", this.previous.bind(this)), this.addEventListener("swipeleft", this.next.bind(this)), this.addEventListener("prev-next:prev", this.previous.bind(this)), this.addEventListener("prev-next:next", this.next.bind(this)), this.addEventListener("page-dots:changed", e => this.select(e.detail.index)), Shopify.designMode && this.addEventListener("shopify:block:select", e => {
          var t;
          null != (t = this.intersectionObserver) && t.disconnect(), !e.detail.load && e.target.selected || this.select(e.target.index, !e.detail.load);
        }), this._blockVerticalScroll()), this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
      }
      get selectedIndex() {
        return this.items.findIndex(e => e.selected);
      }
      async _setupVisibility() {
        await this.untilVisible(), this.items[this.selectedIndex].transitionToEnter();
      }
      previous() {
        this.select((this.selectedIndex - 1 + this.items.length) % this.items.length);
      }
      next() {
        this.select((this.selectedIndex + 1 + this.items.length) % this.items.length);
      }
      async select(e, t = !0) {
        this.hasPendingTransition || (this.hasPendingTransition = !0, await this.items[this.selectedIndex].transitionToLeave(t), this.pageDots && (this.pageDots.selectedIndex = e), await this.items[e].transitionToEnter(t), this.hasPendingTransition = !1);
      }
    }),
    h = (Object.assign(u.prototype, p), window.customElements.define("testimonial-list", u), class extends HTMLElement {
      get index() {
        return [...this.parentNode.children].indexOf(this);
      }
      get selected() {
        return !this.hasAttribute("hidden");
      }
      async transitionToLeave(e = !0) {
        this.setAttribute("hidden", "");
        var t = new T(new P(this, {
          visibility: ["visible", "hidden"]
        }, {
          duration: 500
        }));
        return e ? t.play() : t.finish(), t.finished;
      }
      async transitionToEnter(e = !0) {
        this.removeAttribute("hidden");
        var t = Array.from(this.querySelectorAll(".shop-the-look__dot")),
          t = (t.forEach(e => e.style.opacity = 0), new T(new q([new M(Array.from(this.querySelectorAll(".shop-the-look__image")).map(e => new P(e, {
            opacity: [1, 1]
          }, {
            duration: 0
          }))), new P(this, {
            visibility: ["hidden", "visible"],
            zIndex: [0, 1],
            clipPath: ["inset(0 0 0 100%)", "inset(0 0 0 0)"]
          }, {
            duration: 500,
            easing: "cubic-bezier(1, 0, 0, 1)"
          }), new M(t.map((e, t) => new P(e, {
            opacity: [0, 1],
            transform: ["scale(0)", "scale(1)"]
          }, {
            duration: 120,
            delay: 75 * t,
            easing: "ease-in-out"
          })))])));
        e ? t.play() : t.finish(), await t.finished, window.matchMedia(window.themeVariables.breakpoints.tabletAndUp).matches && null != (e = this.querySelector(".shop-the-look__product-wrapper .shop-the-look__dot")) && e.setAttribute("aria-expanded", "true");
      }
    }),
    u = (window.customElements.define("shop-the-look-item", h), class extends a {
      connectedCallback() {
        this.shopTheLook = this.closest("shop-the-look"), this.inTransition = !1, this.pendingTransition = !1, this.pendingTransitionTo = null, this.delegate.on("click", '[data-action="prev"]', () => this.shopTheLook.previous()), this.delegate.on("click", '[data-action="next"]', () => this.shopTheLook.next());
      }
      transitionToIndex(e, t, i = !0) {
        let s = Array.from(this.querySelectorAll(".shop-the-look__counter-page-transition")),
          n = s[e],
          a = s[t];
        this.inTransition ? (this.pendingTransition = !0, this.pendingTransitionTo = t) : (this.inTransition = !0, n.animate({
          transform: ["translateY(0)", "translateY(-100%)"]
        }, {
          duration: i ? 1e3 : 0,
          easing: "cubic-bezier(1, 0, 0, 1)"
        }).onfinish = () => {
          n.setAttribute("hidden", ""), this.inTransition = !1, this.pendingTransition && this.pendingTransitionTo !== t && (this.pendingTransition = !1, this.transitionToIndex(t, this.pendingTransitionTo, i), this.pendingTransitionTo = null);
        }, a.removeAttribute("hidden"), a.animate({
          transform: ["translateY(100%)", "translateY(0)"]
        }, {
          duration: i ? 1e3 : 0,
          easing: "cubic-bezier(1, 0, 0, 1)"
        }));
      }
    }),
    h = (window.customElements.define("shop-the-look-nav", u), class extends a {
      connectedCallback() {
        this.lookItems = Array.from(this.querySelectorAll("shop-the-look-item")), this.nav = this.querySelector("shop-the-look-nav"), this.hasPendingTransition = !1, this.hasAttribute("reveal-on-scroll") && this._setupVisibility(), 1 < this.lookItems.length && Shopify.designMode && this.addEventListener("shopify:block:select", async e => {
          this.intersectionObserver.disconnect(), await this.select(e.target.index, !e.detail.load), this.nav.animate({
            opacity: [0, 1],
            transform: ["translateY(30px)", "translateY(0)"]
          }, {
            duration: 0,
            fill: "forwards",
            easing: "ease-in-out"
          });
        });
      }
      get selectedIndex() {
        return this.lookItems.findIndex(e => e.selected);
      }
      async _setupVisibility() {
        var e;
        await this.untilVisible();
        for (e of Array.from(this.lookItems[this.selectedIndex].querySelectorAll(".shop-the-look__image"))) null !== e.offsetParent && (await I(e));
        await this.lookItems[this.selectedIndex].transitionToEnter(), this.nav && this.nav.animate({
          opacity: [0, 1],
          transform: ["translateY(30px)", "translateY(0)"]
        }, {
          duration: 150,
          fill: "forwards",
          easing: "ease-in-out"
        });
      }
      previous() {
        this.select((this.selectedIndex - 1 + this.lookItems.length) % this.lookItems.length);
      }
      next() {
        this.select((this.selectedIndex + 1 + this.lookItems.length) % this.lookItems.length);
      }
      async select(e, t = !0) {
        var i = this.lookItems[this.selectedIndex],
          s = this.lookItems[e];
        this.hasPendingTransition || (this.hasPendingTransition = !0, i !== s && (this.nav.transitionToIndex(this.selectedIndex, e, t), i.transitionToLeave()), s.transitionToEnter(t), this.hasPendingTransition = !1);
      }
    }),
    u = (window.customElements.define("shop-the-look", h), class extends a {
      async connectedCallback() {
        this.items = Array.from(this.querySelectorAll(".list-collections__item")), this.hasAttribute("scrollable") && (this.scroller = this.querySelector(".list-collections__scroller"), this.addEventListener("prev-next:prev", this.previous.bind(this)), this.addEventListener("prev-next:next", this.next.bind(this)), this.addEventListener("shopify:block:select", e => e.target.scrollIntoView({
          block: "nearest",
          inline: "center",
          behavior: e.detail.load ? "auto" : "smooth"
        }))), this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
      }
      async _setupVisibility() {
        await this.untilVisible();
        let s = v.prefersReducedMotion();
        var e = new T(new M(this.items.map((e, i) => new q([new P(e.querySelector(".list-collections__item-image"), {
          opacity: [0, 1],
          transform: [`scale(${s ? 1 : 1.1})`, "scale(1)"]
        }, {
          duration: 250,
          delay: s ? 0 : 150 * i,
          easing: "cubic-bezier(0.65, 0, 0.35, 1)"
        }), new M(Array.from(e.querySelectorAll(".list-collections__item-info [reveal]")).map((e, t) => new P(e, {
          opacity: [0, 1],
          clipPath: [`inset(${s ? "0 0 0 0" : "0 0 100% 0"})`, "inset(0 0 0 0)"],
          transform: [`translateY(${s ? 0 : "100%"})`, "translateY(0)"]
        }, {
          duration: 200,
          delay: s ? 0 : 150 * i + 150 * t,
          easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
        })))]))));
        this._hasSectionReloaded ? e.finish() : e.play();
      }
      previous() {
        var e = "ltr" === window.themeVariables.settings.direction ? 1 : -1;
        this.scroller.scrollBy({
          left: -this.items[0].clientWidth * e,
          behavior: "smooth"
        });
      }
      next() {
        var e = "ltr" === window.themeVariables.settings.direction ? 1 : -1;
        this.scroller.scrollBy({
          left: this.items[0].clientWidth * e,
          behavior: "smooth"
        });
      }
    }),
    h = (window.customElements.define("collection-list", u), class extends a {
      constructor() {
        super(), this.productListInner = this.querySelector(".product-list__inner"), this.productItems = Array.from(this.querySelectorAll("product-item"));
      }
      connectedCallback() {
        this.addEventListener("prev-next:prev", this.previous.bind(this)), this.addEventListener("prev-next:next", this.next.bind(this)), !this.hidden && this.staggerApparition && this._staggerProductsApparition();
      }
      get staggerApparition() {
        return this.hasAttribute("stagger-apparition");
      }
      get apparitionAnimation() {
        return this._animation = this._animation || new T(new M(this.productItems.map((e, t) => new P(e, {
          opacity: [0, 1],
          transform: [`translateY(${v.prefersReducedMotion() ? 0 : window.innerWidth < 1e3 ? 35 : 60}px)`, "translateY(0)"]
        }, {
          duration: 600,
          delay: v.prefersReducedMotion() ? 0 : 100 * t - Math.min(3 * t * t, 100 * t),
          easing: "ease"
        }))));
      }
      previous(e) {
        var t = "ltr" === window.themeVariables.settings.direction ? 1 : -1,
          i = parseInt(getComputedStyle(this).getPropertyValue("--product-list-column-gap"));
        e.target.nextElementSibling.removeAttribute("disabled"), e.target.toggleAttribute("disabled", this.productListInner.scrollLeft * t - (this.productListInner.clientWidth + i) <= 0), this.productListInner.scrollBy({
          left: -(this.productListInner.clientWidth + i) * t,
          behavior: "smooth"
        });
      }
      next(e) {
        var t = "ltr" === window.themeVariables.settings.direction ? 1 : -1,
          i = parseInt(getComputedStyle(this).getPropertyValue("--product-list-column-gap"));
        e.target.previousElementSibling.removeAttribute("disabled"), e.target.toggleAttribute("disabled", this.productListInner.scrollLeft * t + 2 * (this.productListInner.clientWidth + i) >= this.productListInner.scrollWidth), this.productListInner.scrollBy({
          left: (this.productListInner.clientWidth + i) * t,
          behavior: "smooth"
        });
      }
      attributeChangedCallback(e) {
        this.staggerApparition && "hidden" === e && (this.hidden ? this.apparitionAnimation.finish() : (this.productListInner.scrollLeft = 0, this.productListInner.parentElement.scrollLeft = 0, null != (e = this.querySelector(".prev-next-button--prev")) && e.setAttribute("disabled", ""), null != (e = this.querySelector(".prev-next-button--next")) && e.removeAttribute("disabled"), this._staggerProductsApparition()));
      }
      async _staggerProductsApparition() {
        this.productItems.forEach(e => e.style.opacity = 0), await this.untilVisible({
          threshold: 0 < this.clientHeight ? Math.min(50 / this.clientHeight, 1) : 0
        }), this.apparitionAnimation.play();
      }
    }),
    u = (e(h, "observedAttributes", ["hidden"]), window.customElements.define("product-list", h), class extends a {
      async connectedCallback() {
        this.items = Array.from(this.querySelectorAll(".logo-list__item")), this.logoListScrollable = this.querySelector(".logo-list__list"), 1 < this.items.length && (this.addEventListener("prev-next:prev", this.previous.bind(this)), this.addEventListener("prev-next:next", this.next.bind(this))), this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
      }
      async _setupVisibility() {
        await this.untilVisible({
          rootMargin: "50px 0px",
          threshold: 0
        });
        var e = new T(new M(this.items.map((e, t) => new P(e, {
          opacity: [0, 1],
          transform: [`translateY(${v.prefersReducedMotion() ? 0 : "30px"})`, "translateY(0)"]
        }, {
          duration: 300,
          delay: v.prefersReducedMotion() ? 0 : 100 * t,
          easing: "ease"
        }))));
        this._hasSectionReloaded ? e.finish() : e.play();
      }
      previous(e) {
        var t = "ltr" === window.themeVariables.settings.direction ? 1 : -1;
        e.target.nextElementSibling.removeAttribute("disabled"), e.target.toggleAttribute("disabled", this.logoListScrollable.scrollLeft * t - (this.logoListScrollable.clientWidth + 24) <= 0), this.logoListScrollable.scrollBy({
          left: -(this.logoListScrollable.clientWidth + 24) * t,
          behavior: "smooth"
        });
      }
      next(e) {
        var t = "ltr" === window.themeVariables.settings.direction ? 1 : -1;
        e.target.previousElementSibling.removeAttribute("disabled"), e.target.toggleAttribute("disabled", this.logoListScrollable.scrollLeft * t + 2 * (this.logoListScrollable.clientWidth + 24) >= this.logoListScrollable.scrollWidth), this.logoListScrollable.scrollBy({
          left: (this.logoListScrollable.clientWidth + 24) * t,
          behavior: "smooth"
        });
      }
    }),
    h = (window.customElements.define("logo-list", u), class extends HTMLElement {
      connectedCallback() {
        window.addEventListener("scroll", g(this._updateProgressBar.bind(this), 15));
      }
      get hasNextArticle() {
        return this.hasAttribute("has-next-article");
      }
      _updateProgressBar() {
        var e = b(),
          t = window.matchMedia(window.themeVariables.breakpoints.pocket).matches ? 40 : 80,
          i = this.getBoundingClientRect(),
          s = this.parentElement.getBoundingClientRect(),
          i = s.bottom - (i.bottom - t),
          i = Math.max(-1 * (i / (s.height + t) - 1), 0);
        this.classList.toggle("is-visible", s.top < e && s.bottom > e + this.clientHeight - t), this.hasNextArticle && (.8 < i ? this.classList.add("article__nav--show-next") : this.classList.remove("article__nav--show-next")), this.style.setProperty("--transform", "" + i);
      }
    }),
    u = (window.customElements.define("blog-post-navigation", h), class extends a {
      connectedCallback() {
        this.hasAttribute("stack") || (this.multiColumnInner = this.querySelector(".multi-column__inner"), this.addEventListener("prev-next:prev", this.previous.bind(this)), this.addEventListener("prev-next:next", this.next.bind(this)), Shopify.designMode && this.addEventListener("shopify:block:select", e => {
          e.target.scrollIntoView({
            inline: "center",
            block: "nearest",
            behavior: e.detail.load ? "auto" : "smooth"
          });
        })), this.hasAttribute("stagger-apparition") && this._setupVisibility();
      }
      async _setupVisibility() {
        await this.untilVisible({
          threshold: Math.min(50 / this.clientHeight, 1)
        });
        let i = v.prefersReducedMotion();
        var e = new T(new M(Array.from(this.querySelectorAll(".multi-column__item")).map((e, t) => new P(e, {
          opacity: [0, 1],
          transform: [`translateY(${v.prefersReducedMotion() ? 0 : window.innerWidth < 1e3 ? 35 : 60}px)`, "translateY(0)"]
        }, {
          duration: 600,
          delay: i ? 0 : 100 * t,
          easing: "ease"
        }))));
        this._hasSectionReloaded ? e.finish() : e.play();
      }
      previous(e) {
        var t = "ltr" === window.themeVariables.settings.direction ? 1 : -1,
          i = parseInt(getComputedStyle(this).getPropertyValue("--multi-column-column-gap"));
        e.target.nextElementSibling.removeAttribute("disabled"), e.target.toggleAttribute("disabled", this.multiColumnInner.scrollLeft * t - (this.multiColumnInner.clientWidth + i) <= 0), this.multiColumnInner.scrollBy({
          left: -(this.multiColumnInner.clientWidth + i) * t,
          behavior: "smooth"
        });
      }
      next(e) {
        var t = "ltr" === window.themeVariables.settings.direction ? 1 : -1,
          i = parseInt(getComputedStyle(this).getPropertyValue("--multi-column-column-gap"));
        e.target.previousElementSibling.removeAttribute("disabled"), e.target.toggleAttribute("disabled", this.multiColumnInner.scrollLeft * t + 2 * (this.multiColumnInner.clientWidth + i) >= this.multiColumnInner.scrollWidth), this.multiColumnInner.scrollBy({
          left: (this.multiColumnInner.clientWidth + i) * t,
          behavior: "smooth"
        });
      }
    }),
    h = (window.customElements.define("multi-column", u), class extends HTMLElement {
      connectedCallback() {
        this.listItems = Array.from(this.querySelectorAll("gallery-item")), this.scrollBarElement = this.querySelector(".gallery__progress-bar"), this.listWrapperElement = this.querySelector(".gallery__list-wrapper"), 1 < this.listItems.length && (this.addEventListener("scrollable-content:progress", this._updateProgressBar.bind(this)), this.addEventListener("prev-next:prev", this.previous.bind(this)), this.addEventListener("prev-next:next", this.next.bind(this)), Shopify.designMode) && this.addEventListener("shopify:block:select", e => this.select(e.target.index, !e.detail.load));
      }
      previous() {
        this.select([...this.listItems].reverse().find(e => e.isOnLeftHalfPartOfScreen).index);
      }
      next() {
        this.select(this.listItems.findIndex(e => e.isOnRightHalfPartOfScreen));
      }
      select(e, t = !0) {
        e = this.listItems[e].getBoundingClientRect();
        this.listWrapperElement.scrollBy({
          behavior: t ? "smooth" : "auto",
          left: Math.floor(e.left - window.innerWidth / 2 + e.width / 2)
        });
      }
      _updateProgressBar(e) {
        var t;
        null != (t = this.scrollBarElement) && t.style.setProperty("--transform", e.detail.progress + "%");
      }
    }),
    u = (window.customElements.define("gallery-list", h), class extends HTMLElement {
      get index() {
        return [...this.parentNode.children].indexOf(this);
      }
      get isOnRightHalfPartOfScreen() {
        return "ltr" === window.themeVariables.settings.direction ? this.getBoundingClientRect().left > window.innerWidth / 2 : this.getBoundingClientRect().right < window.innerWidth / 2;
      }
      get isOnLeftHalfPartOfScreen() {
        return "ltr" === window.themeVariables.settings.direction ? this.getBoundingClientRect().right < window.innerWidth / 2 : this.getBoundingClientRect().left > window.innerWidth / 2;
      }
    }),
    h = (window.customElements.define("gallery-item", u), class extends a {
      connectedCallback() {
        this.hasAttribute("parallax") && !v.prefersReducedMotion() && (this._hasPendingRaF = !1, this._onScrollListener = this._onScroll.bind(this), window.addEventListener("scroll", this._onScrollListener)), this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
      }
      disconnectedCallback() {
        super.disconnectedCallback(), this._onScrollListener && window.removeEventListener("scroll", this._onScrollListener);
      }
      async _setupVisibility() {
        await this.untilVisible();
        let e = this.querySelector(".image-overlay__image"),
          t = await L(this.querySelectorAll("split-lines")),
          i = v.prefersReducedMotion();
        await I(e);
        var s = [new P(e, {
            opacity: [0, 1],
            transform: [`scale(${i ? 1 : 1.1})`, "scale(1)"]
          }, {
            duration: 500,
            easing: "cubic-bezier(0.65, 0, 0.35, 1)"
          }), new M(t.map((e, t) => new P(e, {
            opacity: [0, .2, 1],
            transform: [`translateY(${i ? 0 : "100%"})`, "translateY(0)"],
            clipPath: [`inset(${i ? "0 0 0 0" : "0 0 100% 0"})`, "inset(0 0 0 0)"]
          }, {
            duration: 300,
            delay: i ? 0 : 120 * t,
            easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
          }))), new P(this.querySelector(".image-overlay__text-container"), {
            opacity: [0, 1]
          }, {
            duration: 300
          })],
          s = i ? new T(new M(s)) : new T(new q(s));
        this._hasSectionReloaded ? s.finish() : s.play();
      }
      _onScroll() {
        this._hasPendingRaF || (this._hasPendingRaF = !0, requestAnimationFrame(() => {
          var e = this.getBoundingClientRect(),
            t = this.querySelector(".image-overlay__content-wrapper"),
            i = this.querySelector(".image-overlay__image"),
            s = e.bottom,
            e = e.height,
            n = b();
          t && (t.style.opacity = Math.max(1 - 3 * (1 - Math.min(s / e, 1)), 0).toString()), i && (i.style.transform = `translateY(${100 - 100 * Math.max(1 - (1 - Math.min(s / (e + n), 1)), 0)}px)`), this._hasPendingRaF = !1;
        }));
      }
    }),
    u = (window.customElements.define("image-with-text-overlay", h), class extends a {
      async connectedCallback() {
        this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
      }
      async _setupVisibility() {
        await this.untilVisible();
        let e = Array.from(this.querySelectorAll(".image-with-text-block__image[reveal]")),
          t = await L(this.querySelectorAll("split-lines")),
          i = v.prefersReducedMotion();
        for (var s of e) null !== s.offsetParent && (await I(s));
        var n = [new M(e.map(e => new P(e, {
            opacity: [0, 1],
            transform: [`scale(${i ? 1 : 1.1})`, "scale(1)"]
          }, {
            duration: 500,
            easing: "cubic-bezier(0.65, 0, 0.35, 1)"
          }))), new P(this.querySelector(".image-with-text-block__content"), {
            opacity: [0, 1],
            transform: [`translateY(${i ? 0 : "60px"})`, "translateY(0)"]
          }, {
            duration: 150,
            easing: "ease-in-out"
          }), new M(t.map((e, t) => new P(e, {
            opacity: [0, .2, 1],
            transform: [`translateY(${i ? 0 : "100%"})`, "translateY(0)"],
            clipPath: [`inset(${i ? "0 0 0 0" : "0 0 100% 0"})`, "inset(0 0 0 0)"]
          }, {
            duration: 300,
            delay: i ? 0 : 120 * t,
            easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
          }))), new P(this.querySelector(".image-with-text-block__text-container"), {
            opacity: [0, 1]
          }, {
            duration: 300
          })],
          n = i ? new T(new M(n)) : new T(new q(n));
        this._hasSectionReloaded ? n.finish() : n.play();
      }
    }),
    h = (window.customElements.define("image-with-text-block", u), class extends a {
      async connectedCallback() {
        var e;
        this.articleItems = Array.from(this.querySelectorAll(".article-item")), this.staggerApparition && (await this.untilVisible({
          threshold: 0 < this.clientHeight ? Math.min(50 / this.clientHeight, 1) : 0
        }), e = new T(new M(this.articleItems.map((e, t) => new P(e, {
          opacity: [0, 1],
          transform: [`translateY(${v.prefersReducedMotion() ? 0 : window.innerWidth < 1e3 ? 35 : 60}px)`, "translateY(0)"]
        }, {
          duration: 600,
          delay: v.prefersReducedMotion() ? 0 : 100 * t - Math.min(3 * t * t, 100 * t),
          easing: "ease"
        })))), this._hasSectionReloaded ? e.finish() : e.play());
      }
      get staggerApparition() {
        return this.hasAttribute("stagger-apparition");
      }
    }),
    u = (window.customElements.define("article-list", h), class extends HTMLElement {
      async connectedCallback() {
        var e = this.querySelector(".article__image");
        v.prefersReducedMotion() ? e.removeAttribute("reveal") : (await I(e), e.animate({
          opacity: [0, 1],
          transform: ["scale(1.1)", "scale(1)"]
        }, {
          duration: 500,
          fill: "forwards",
          easing: "cubic-bezier(0.65, 0, 0.35, 1)"
        }));
      }
    }),
    h = (window.customElements.define("blog-post-header", u), class extends HTMLInputElement {
      connectedCallback() {
        this.addEventListener("click", () => document.getElementById(this.getAttribute("aria-controls")).open = !0);
      }
    }),
    u = (window.customElements.define("predictive-search-input", h, {
      extends: "input"
    }), class extends r {
      connectedCallback() {
        var e;
        super.connectedCallback(), this.hasAttribute("reverse-breakpoint") && (this.originalDirection = this.classList.contains("drawer--from-left") ? "left" : "right", (e = window.matchMedia(this.getAttribute("reverse-breakpoint"))).addListener(this._checkReverseOpeningDirection.bind(this)), this._checkReverseOpeningDirection(e)), this.delegate.on("click", ".drawer__overlay", () => this.open = !1);
      }
      attributeChangedCallback(e, t, i) {
        super.attributeChangedCallback(e, t, i), "open" === e && document.documentElement.classList.toggle("lock-all", this.open);
      }
      _checkReverseOpeningDirection(e) {
        this.classList.remove("drawer--from-left"), ("left" === this.originalDirection && !e.matches || "left" !== this.originalDirection && e.matches) && this.classList.add("drawer--from-left");
      }
    }),
    h = (window.customElements.define("drawer-content", u), class extends u {
      connectedCallback() {
        super.connectedCallback(), this.inputElement = this.querySelector('[name="q"]'), this.drawerContentElement = this.querySelector(".drawer__content"), this.drawerFooterElement = this.querySelector(".drawer__footer"), this.loadingStateElement = this.querySelector(".predictive-search__loading-state"), this.resultsElement = this.querySelector(".predictive-search__results"), this.menuListElement = this.querySelector(".predictive-search__menu-list"), this.delegate.on("input", '[name="q"]', this._debounce(this._onSearch.bind(this), 200)), this.delegate.on("click", '[data-action="reset-search"]', this._startNewSearch.bind(this));
      }
      async _onSearch(e, t) {
        if ("Enter" !== e.key) if (this.abortController && this.abortController.abort(), this.drawerContentElement.classList.remove("drawer__content--center"), this.drawerFooterElement.hidden = !0, "" === t.value) this.loadingStateElement.hidden = !0, this.resultsElement.hidden = !0, this.menuListElement && (this.menuListElement.hidden = !1);else {
          this.drawerContentElement.classList.add("drawer__content--center"), this.loadingStateElement.hidden = !1, this.resultsElement.hidden = !0, this.menuListElement && (this.menuListElement.hidden = !0);
          let e = {};
          try {
            this.abortController = new AbortController(), e = this._supportPredictiveApi() ? await this._doPredictiveSearch(t.value) : await this._doLiquidSearch(t.value);
          } catch (e) {
            if ("AbortError" === e.name) return;
          }
          this.loadingStateElement.hidden = !0, this.resultsElement.hidden = !1, this.menuListElement && (this.menuListElement.hidden = !0), e.hasResults && (this.drawerFooterElement.hidden = !1, this.drawerContentElement.classList.remove("drawer__content--center")), this.resultsElement.innerHTML = e.html;
        }
      }
      async _doPredictiveSearch(e) {
        var e = await fetch(`${window.themeVariables.routes.predictiveSearchUrl}?q=${encodeURIComponent(e)}&resources[limit]=10&resources[limit_scope]=each&section_id=predictive-search`, {
            signal: this.abortController.signal
          }),
          t = document.createElement("div");
        return t.innerHTML = await e.text(), {
          hasResults: null !== t.querySelector(".predictive-search__results-categories"),
          html: t.firstElementChild.innerHTML
        };
      }
      async _doLiquidSearch(e) {
        var e = await fetch(`${window.themeVariables.routes.searchUrl}?q=${encodeURIComponent(e)}&resources[limit]=50&section_id=predictive-search-compatibility`, {
            signal: this.abortController.signal
          }),
          t = document.createElement("div");
        return t.innerHTML = await e.text(), {
          hasResults: null !== t.querySelector(".predictive-search__results-categories"),
          html: t.firstElementChild.innerHTML
        };
      }
      _startNewSearch() {
        this.inputElement.value = "", this.inputElement.focus();
        var e = new Event("input", {
          bubbles: !0,
          cancelable: !0
        });
        this.inputElement.dispatchEvent(e);
      }
      _supportPredictiveApi() {
        return JSON.parse(document.getElementById("shopify-features").innerHTML).predictiveSearch;
      }
      _debounce(t, i) {
        let s = null;
        return (...e) => {
          clearTimeout(s), s = setTimeout(() => {
            t.apply(this, e);
          }, i);
        };
      }
    }),
    h = (window.customElements.define("predictive-search-drawer", h), class extends HTMLElement {
      connectedCallback() {
        var e;
        this.prevNextButtons = this.querySelector("prev-next-buttons"), this.pageDots = this.querySelector("page-dots"), this.scrollBarElement = this.querySelector(".timeline__progress-bar"), this.listWrapperElement = this.querySelector(".timeline__list-wrapper"), this.listItemElements = Array.from(this.querySelectorAll(".timeline__item")), this.isScrolling = !1, 1 < this.listItemElements.length && (this.addEventListener("prev-next:prev", this.previous.bind(this)), this.addEventListener("prev-next:next", this.next.bind(this)), this.addEventListener("page-dots:changed", e => this.select(e.detail.index)), Shopify.designMode && this.addEventListener("shopify:block:select", e => {
          this.select([...e.target.parentNode.children].indexOf(e.target), !e.detail.load);
        }), this.itemIntersectionObserver = new IntersectionObserver(this._onItemObserved.bind(this), {
          threshold: .4
        }), (e = window.matchMedia(window.themeVariables.breakpoints.pocket)).addListener(this._onMediaChanged.bind(this)), this._onMediaChanged(e));
      }
      get selectedIndex() {
        return this.listItemElements.findIndex(e => !e.hasAttribute("hidden"));
      }
      previous() {
        this.select(Math.max(0, this.selectedIndex - 1));
      }
      next() {
        this.select(Math.min(this.selectedIndex + 1, this.listItemElements.length - 1));
      }
      select(e, t = !0) {
        var i = this.listItemElements[e].getBoundingClientRect();
        t && (this.isScrolling = !0, setTimeout(() => this.isScrolling = !1, 800)), window.matchMedia(window.themeVariables.breakpoints.pocket).matches ? this.listWrapperElement.scrollTo({
          behavior: t ? "smooth" : "auto",
          left: this.listItemElements[0].clientWidth * e
        }) : this.listWrapperElement.scrollBy({
          behavior: t ? "smooth" : "auto",
          left: Math.floor(i.left - window.innerWidth / 2 + i.width / 2)
        }), this._onItemSelected(e);
      }
      _onItemSelected(e) {
        var t = this.listItemElements[e];
        t.removeAttribute("hidden", "false"), w(t).forEach(e => e.setAttribute("hidden", "")), this.prevNextButtons.isPrevDisabled = 0 === e, this.prevNextButtons.isNextDisabled = e === this.listItemElements.length - 1, this.pageDots.selectedIndex = e, null != (t = this.scrollBarElement) && t.style.setProperty("--transform", 100 / (this.listItemElements.length - 1) * e + "%");
      }
      _onItemObserved(e) {
        this.isScrolling || e.forEach(e => {
          e.isIntersecting && this._onItemSelected([...e.target.parentNode.children].indexOf(e.target));
        });
      }
      _onMediaChanged(e) {
        e.matches ? this.listItemElements.forEach(e => this.itemIntersectionObserver.observe(e)) : this.listItemElements.forEach(e => this.itemIntersectionObserver.unobserve(e));
      }
    }),
    h = (window.customElements.define("time-line", h), class extends a {
      connectedCallback() {
        this.pressItemsWrapper = this.querySelector(".press-list__wrapper"), this.pressItems = Array.from(this.querySelectorAll("press-item")), this.pageDots = this.querySelector("page-dots"), 1 < this.pressItems.length && (Shopify.designMode && this.addEventListener("shopify:block:select", e => {
          var t;
          null != (t = this.intersectionObserver) && t.disconnect(), !e.detail.load && e.target.selected || this.select(e.target.index, !e.detail.load);
        }), this.pressItemsWrapper.addEventListener("swiperight", this.previous.bind(this)), this.pressItemsWrapper.addEventListener("swipeleft", this.next.bind(this)), this.addEventListener("page-dots:changed", e => this.select(e.detail.index)), this._blockVerticalScroll()), this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
      }
      async _setupVisibility() {
        await this.untilVisible(), this.pressItems[this.selectedIndex].transitionToEnter();
      }
      get selectedIndex() {
        return this.pressItems.findIndex(e => e.selected);
      }
      previous() {
        this.select((this.selectedIndex - 1 + this.pressItems.length) % this.pressItems.length);
      }
      next() {
        this.select((this.selectedIndex + 1 + this.pressItems.length) % this.pressItems.length);
      }
      async select(e, t = !0) {
        var i = this.pressItems[this.selectedIndex],
          s = this.pressItems[e];
        await i.transitionToLeave(t), this.pageDots.selectedIndex = e, await s.transitionToEnter(t);
      }
    }),
    p = (Object.assign(h.prototype, p), window.customElements.define("press-list", h), class extends HTMLElement {
      connectedCallback() {
        this.addEventListener("split-lines:re-split", e => {
          Array.from(e.target.children).forEach(e => e.style.visibility = this.selected ? "visible" : "hidden");
        });
      }
      get index() {
        return [...this.parentNode.children].indexOf(this);
      }
      get selected() {
        return !this.hasAttribute("hidden");
      }
      async transitionToLeave(e = !0) {
        var t = await L(this.querySelectorAll("split-lines")),
          t = new T(new M(t.reverse().map((e, t) => new P(e, {
            visibility: ["visible", "hidden"],
            clipPath: ["inset(0 0 0 0)", "inset(0 0 100% 0)"],
            transform: ["translateY(0)", "translateY(100%)"]
          }, {
            duration: 350,
            delay: 60 * t,
            easing: "cubic-bezier(0.68, 0.00, 0.77, 0.00)"
          }))));
        e ? t.play() : t.finish(), await t.finished, this.setAttribute("hidden", "");
      }
      async transitionToEnter(e = !0) {
        this.removeAttribute("hidden");
        var t = await L(this.querySelectorAll("split-lines, .testimonial__author")),
          t = new T(new M(t.map((e, t) => new P(e, {
            visibility: ["hidden", "visible"],
            clipPath: ["inset(0 0 100% 0)", "inset(0 0 0px 0)"],
            transform: ["translateY(100%)", "translateY(0)"]
          }, {
            duration: 550,
            delay: 120 * t,
            easing: "cubic-bezier(0.23, 1, 0.32, 1)"
          }))));
        return e ? t.play() : t.finish(), t.finished;
      }
    }),
    h = (window.customElements.define("press-item", p), class extends a {
      connectedCallback() {
        this.openingTimeout = null, this.currentMegaMenu = null, this.delegate.on("mouseenter", ".has-dropdown", (e, t) => {
          e.target === t && null !== e.relatedTarget && this.openDropdown(t);
        }, !0), this.delegate.on("click", ".header__linklist-link[aria-expanded], .nav-dropdown__link[aria-expanded]", (e, t) => {
          window.matchMedia("(hover: hover)").matches || "true" === t.getAttribute("aria-expanded") || (e.preventDefault(), this.openDropdown(t.parentElement));
        }), this.delegate.on("shopify:block:select", e => this.openDropdown(e.target.parentElement)), this.delegate.on("shopify:block:deselect", e => this.closeDropdown(e.target.parentElement));
      }
      openDropdown(s) {
        let n = s.querySelector("[aria-controls]"),
          a = s.querySelector("#" + n.getAttribute("aria-controls")),
          r = (this.currentMegaMenu = a.classList.contains("mega-menu") ? a : null, setTimeout(() => {
            if ("true" !== n.getAttribute("aria-expanded")) {
              var i;
              n.setAttribute("aria-expanded", "true"), a.removeAttribute("hidden"), a.classList.contains("mega-menu") && !v.prefersReducedMotion() && ((i = Array.from(a.querySelectorAll(".mega-menu__column, .mega-menu__image-push"))).forEach(e => {
                e.getAnimations().forEach(e => e.cancel()), e.style.opacity = 0;
              }), new T(new M(i.map((e, t) => new P(e, {
                opacity: [0, 1],
                transform: ["translateY(20px)", "translateY(0)"]
              }, {
                duration: 250,
                delay: 100 + 60 * t,
                easing: "cubic-bezier(0.65, 0, 0.35, 1)"
              })))).play());
              let t = e => {
                  null !== e.relatedTarget && (this.closeDropdown(s), s.removeEventListener("mouseleave", t));
                },
                e = () => {
                  this.closeDropdown(s), document.documentElement.removeEventListener("mouseleave", e);
                };
              s.addEventListener("mouseleave", t), document.documentElement.addEventListener("mouseleave", e), r = null, this.dispatchEvent(new CustomEvent("desktop-nav:dropdown:open", {
                bubbles: !0
              }));
            }
          }, 100));
        s.addEventListener("mouseleave", () => {
          r && clearTimeout(r);
        }, {
          once: !0
        });
      }
      closeDropdown(e) {
        let t = e.querySelector("[aria-controls]"),
          i = e.querySelector("#" + t.getAttribute("aria-controls"));
        requestAnimationFrame(() => {
          i.classList.add("is-closing"), t.setAttribute("aria-expanded", "false"), setTimeout(() => {
            i.setAttribute("hidden", ""), clearTimeout(this.openingTimeout), i.classList.remove("is-closing");
          }, i.classList.contains("mega-menu") && this.currentMegaMenu !== i ? 250 : 0), this.dispatchEvent(new CustomEvent("desktop-nav:dropdown:close", {
            bubbles: !0
          }));
        });
      }
    }),
    p = (window.customElements.define("desktop-navigation", h), class extends u {
      get apparitionAnimation() {
        var e, t, i;
        return this._apparitionAnimation || (v.prefersReducedMotion() ? void 0 : (e = Array.from(this.querySelectorAll('.mobile-nav__item[data-level="1"]')), (t = []).push(new M(e.map((e, t) => new P(e, {
          opacity: [0, 1],
          transform: ["translateX(-40px)", "translateX(0)"]
        }, {
          duration: 300,
          delay: 300 + 120 * t - Math.min(2 * t * t, 120 * t),
          easing: "cubic-bezier(0.25, 1, 0.5, 1)"
        })))), (i = this.querySelector(".drawer__footer")) && t.push(new P(i, {
          opacity: [0, 1],
          transform: ["translateY(100%)", "translateY(0)"]
        }, {
          duration: 300,
          delay: 500 + Math.max(125 * e.length - 25 * e.length, 25),
          easing: "cubic-bezier(0.25, 1, 0.5, 1)"
        })), this._apparitionAnimation = new T(new M(t))));
      }
      attributeChangedCallback(e, t, i) {
        super.attributeChangedCallback(e, t, i), "open" === e && (this.open && this.apparitionAnimation && (Array.from(this.querySelectorAll('.mobile-nav__item[data-level="1"], .drawer__footer')).forEach(e => e.style.opacity = 0), this.apparitionAnimation.play()), n(this, this.open ? "mobile-nav:open" : "mobile-nav:close"));
      }
    }),
    h = (window.customElements.define("mobile-navigation", p), class extends a {
      connectedCallback() {
        window.ResizeObserver && (this.resizeObserver = new ResizeObserver(this._updateCustomProperties.bind(this)), this.resizeObserver.observe(this), this.resizeObserver.observe(this.querySelector(".header__wrapper"))), this.isTransparent && (this.isTransparencyDetectionLocked = !1, this.delegate.on("desktop-nav:dropdown:open", () => this.lockTransparency = !0), this.delegate.on("desktop-nav:dropdown:close", () => this.lockTransparency = !1), this.rootDelegate.on("mobile-nav:open", () => this.lockTransparency = !0), this.rootDelegate.on("mobile-nav:close", () => this.lockTransparency = !1), this.delegate.on("mouseenter", this._checkTransparentHeader.bind(this), !0), this.delegate.on("mouseleave", this._checkTransparentHeader.bind(this)), this.isSticky) && (this._checkTransparentHeader(), this._onWindowScrollListener = g(this._checkTransparentHeader.bind(this), 100), window.addEventListener("scroll", this._onWindowScrollListener));
      }
      disconnectedCallback() {
        super.disconnectedCallback(), window.ResizeObserver && this.resizeObserver.disconnect(), this.isTransparent && this.isSticky && window.removeEventListener("scroll", this._onWindowScrollListener);
      }
      get isSticky() {
        return this.hasAttribute("sticky");
      }
      get isTransparent() {
        return this.hasAttribute("transparent");
      }
      get transparentHeaderThreshold() {
        return 25;
      }
      set lockTransparency(e) {
        this.isTransparencyDetectionLocked = e, this._checkTransparentHeader();
      }
      _updateCustomProperties(e) {
        e.forEach(e => {
          var t;
          e.target === this && (t = e.borderBoxSize ? (0 < e.borderBoxSize.length ? e.borderBoxSize[0] : e.borderBoxSize).blockSize : e.target.clientHeight, document.documentElement.style.setProperty("--header-height", t + "px")), e.target.classList.contains("header__wrapper") && (t = e.borderBoxSize ? (0 < e.borderBoxSize.length ? e.borderBoxSize[0] : e.borderBoxSize).blockSize : e.target.clientHeight, document.documentElement.style.setProperty("--header-height-without-bottom-nav", t + "px"));
        });
      }
      _checkTransparentHeader(e) {
        this.isTransparencyDetectionLocked || window.scrollY > this.transparentHeaderThreshold || e && "mouseenter" === e.type ? this.classList.remove("header--transparent") : this.classList.add("header--transparent");
      }
    }),
    p = (window.customElements.define("store-header", h), class extends HTMLElement {
      connectedCallback() {
        let e,
          t = Array.from(this.querySelectorAll('[name*="properties"]')),
          i = "properties[__shopify_send_gift_card_to_recipient]";
        this.recipientCheckbox = t.find(e => e.name === i), this.recipientOtherProperties = t.filter(e => e.name !== i), this.recipientFieldsContainer = this.querySelector(".gift-card-recipient__fields"), null != (e = this.recipientCheckbox) && e.addEventListener("change", this._synchronizeProperties.bind(this)), this._synchronizeProperties();
      }
      _synchronizeProperties() {
        this.recipientOtherProperties.forEach(e => e.disabled = !this.recipientCheckbox.checked), this.recipientFieldsContainer.classList.toggle("js:hidden", !this.recipientCheckbox.checked);
      }
    }),
    oe = (window.customElements.get("gift-card-recipient") || window.customElements.define("gift-card-recipient", p), class {
      constructor(e) {
        this.photoSwipeInstance = e, this.delegate = new i(this.photoSwipeInstance.scrollWrap), this.maxSpreadZoom = window.themeVariables.settings.mobileZoomFactor || 2, this.pswpUi = this.photoSwipeInstance.scrollWrap.querySelector(".pswp__ui"), this.delegate.on("click", '[data-action="pswp-close"]', this._close.bind(this)), this.delegate.on("click", '[data-action="pswp-prev"]', this._goToPrev.bind(this)), this.delegate.on("click", '[data-action="pswp-next"]', this._goToNext.bind(this)), this.delegate.on("click", '[data-action="pswp-move-to"]', this._moveTo.bind(this)), this.photoSwipeInstance.listen("close", this._onPswpClosed.bind(this)), this.photoSwipeInstance.listen("doubleTap", this._onPswpDoubleTap.bind(this)), this.photoSwipeInstance.listen("beforeChange", this._onPswpBeforeChange.bind(this)), this.photoSwipeInstance.listen("initialZoomInEnd", this._onPswpInitialZoomInEnd.bind(this)), this.photoSwipeInstance.listen("initialZoomOut", this._onPswpInitialZoomOut.bind(this)), this.photoSwipeInstance.listen("parseVerticalMargin", this._onPswpParseVerticalMargin.bind(this)), this.delegate.on("pswpTap", ".pswp__img", this._onPswpTap.bind(this));
      }
      init() {
        var e = this.pswpUi.querySelector(".pswp__prev-next-buttons"),
          t = this.pswpUi.querySelector(".pswp__dots-nav-wrapper");
        if (this.photoSwipeInstance.items.length <= 1) e.style.display = "none", t.style.display = "none";else {
          e.style.display = "";
          let i = t.style.display = "";
          this.photoSwipeInstance.items.forEach((e, t) => {
            i += `
        <button class="dots-nav__item tap-area" ${0 === t ? 'aria-current="true"' : ""} data-action="pswp-move-to">
          <span class="visually-hidden">Go to slide ${t}</span>
        </button>
      `;
          }), t.querySelector(".pswp__dots-nav-wrapper .dots-nav").innerHTML = i;
        }
      }
      _close() {
        this.photoSwipeInstance.close();
      }
      _goToPrev() {
        this.photoSwipeInstance.prev();
      }
      _goToNext() {
        this.photoSwipeInstance.next();
      }
      _moveTo(e, t) {
        this.photoSwipeInstance.goTo([...t.parentNode.children].indexOf(t));
      }
      _onPswpClosed() {
        this.delegate.off("pswpTap");
      }
      _onPswpDoubleTap(e) {
        var t = this.photoSwipeInstance.currItem.initialZoomLevel;
        this.photoSwipeInstance.getZoomLevel() !== t ? this.photoSwipeInstance.zoomTo(t, e, 333) : this.photoSwipeInstance.zoomTo(t < .7 ? 1 : this.maxSpreadZoom, e, 333);
      }
      _onPswpTap(e) {
        "mouse" === e.detail.pointerType && this.photoSwipeInstance.toggleDesktopZoom(e.detail.releasePoint);
      }
      _onPswpBeforeChange() {
        var e;
        this.photoSwipeInstance.items.length <= 1 || ((e = this.photoSwipeInstance.scrollWrap.querySelector(`.dots-nav__item:nth-child(${this.photoSwipeInstance.getCurrentIndex() + 1})`)).setAttribute("aria-current", "true"), w(e).forEach(e => e.removeAttribute("aria-current")));
      }
      _onPswpInitialZoomInEnd() {
        var e;
        null != (e = this.pswpUi) && e.classList.remove("pswp__ui--hidden");
      }
      _onPswpInitialZoomOut() {
        var e;
        null != (e = this.pswpUi) && e.classList.add("pswp__ui--hidden");
      }
      _onPswpParseVerticalMargin(e) {
        e.vGap.bottom = this.photoSwipeInstance.items.length <= 1 || window.matchMedia(window.themeVariables.breakpoints.lapAndUp).matches ? 0 : 60;
      }
    }),
    h = (window.customElements.define("product-image-zoom", class extends r {
      connectedCallback() {
        super.connectedCallback(), this.mediaElement = this.closest(".product__media"), this.maxSpreadZoom = window.themeVariables.settings.mobileZoomFactor || 2, f.load("photoswipe");
      }
      disconnectedCallback() {
        var e;
        super.disconnectedCallback(), null != (e = this.photoSwipeInstance) && e.destroy();
      }
      async attributeChangedCallback(e, t, i) {
        super.attributeChangedCallback(e, t, i), "open" === e && this.open && (await f.load("photoswipe"), this._openPhotoSwipe());
      }
      async _openPhotoSwipe() {
        var e = await this._buildItems();
        this.photoSwipeInstance = new window.ThemePhotoSwipe(this, oe, e, {
          index: e.findIndex(e => e.selected),
          maxSpreadZoom: this.maxSpreadZoom,
          loop: !1,
          allowPanToNext: !1,
          closeOnScroll: !1,
          closeOnVerticalDrag: v.supportsHover(),
          showHideOpacity: !0,
          arrowKeys: !0,
          history: !1,
          getThumbBoundsFn: () => {
            var e = this.mediaElement.querySelector(".product__media-item.is-selected"),
              t = window.pageYOffset || document.documentElement.scrollTop,
              e = e.getBoundingClientRect();
            return {
              x: e.left,
              y: e.top + t,
              w: e.width
            };
          },
          getDoubleTapZoom: (e, t) => e ? t.w > t.h ? 1.6 : 1 : t.initialZoomLevel < .7 ? 1 : 1.33
        });
        let s = null;
        this.photoSwipeInstance.updateSize = new Proxy(this.photoSwipeInstance.updateSize, {
          apply: (e, t, i) => {
            s !== window.innerWidth && (e(arguments), s = window.innerWidth);
          }
        }), this.photoSwipeInstance.listen("close", () => {
          this.open = !1;
        }), this.photoSwipeInstance.init();
      }
      async _buildItems() {
        let e = Array.from(this.mediaElement.querySelectorAll('.product__media-item[data-media-type="image"]:not(.is-filtered)')),
          s = await A.load(this.getAttribute("product-handle"));
        return Promise.resolve(e.map(t => {
          var e = s.media.find(e => e.id === parseInt(t.getAttribute("data-media-id"))),
            i = re(e, [200, 300, 400, 500, 600, 700, 800, 1e3, 1200, 1400, 1600, 1800, 2e3, 2200, 2400, 2600, 2800, 3e3]),
            i = Math.min(i[i.length - 1], window.innerWidth);
          return {
            selected: t.classList.contains("is-selected"),
            src: k(e, Math.ceil(Math.min(i * window.devicePixelRatio * this.maxSpreadZoom, 3e3)) + "x"),
            msrc: t.firstElementChild.currentSrc,
            originalMedia: e,
            w: i,
            h: parseInt(i / e.aspect_ratio)
          };
        }));
      }
    }), class extends HTMLElement {
      connectedCallback() {
        var e = this.querySelector("script");
        e && (this.inventories = JSON.parse(e.innerHTML), null != (e = document.getElementById(this.getAttribute("form-id")))) && e.addEventListener("variant:changed", this._onVariantChanged.bind(this));
      }
      _onVariantChanged(e) {
        var t;
        null != (t = this.querySelector("span")) && t.remove(), e.detail.variant && "" !== this.inventories[e.detail.variant.id] ? (this.hidden = !1, this.insertAdjacentHTML("afterbegin", this.inventories[e.detail.variant.id])) : this.hidden = !0;
      }
    }),
    p = (window.customElements.define("product-inventory", h), class extends HTMLElement {
      connectedCallback() {
        var e;
        null != (e = document.getElementById(this.getAttribute("form-id"))) && e.addEventListener("variant:changed", this._onVariantChanged.bind(this)), Shopify.designMode && Shopify.PaymentButton && Shopify.PaymentButton.init();
      }
      _onVariantChanged(e) {
        this._updateAddToCartButton(e.detail.variant), this._updateDynamicCheckoutButton(e.detail.variant);
      }
      _updateAddToCartButton(t) {
        var i = this.querySelector("[data-product-add-to-cart-button]");
        if (i) {
          let e = "";
          i.classList.remove("button--primary", "button--secondary", "button--ternary"), e = t ? t.available ? (i.removeAttribute("disabled"), i.classList.add(i.hasAttribute("data-use-primary") ? "button--primary" : "button--secondary"), i.getAttribute("data-button-content")) : (i.setAttribute("disabled", "disabled"), i.classList.add("button--ternary"), window.themeVariables.strings.productFormSoldOut) : (i.setAttribute("disabled", "disabled"), i.classList.add("button--ternary"), window.themeVariables.strings.productFormUnavailable), "loader-button" === i.getAttribute("is") ? i.firstElementChild.innerHTML = e : i.innerHTML = e;
        }
      }
      _updateDynamicCheckoutButton(e) {
        var t = this.querySelector(".shopify-payment-button");
        t && (t.style.display = e && e.available ? "block" : "none");
      }
    }),
    r = (window.customElements.define("product-payment-container", p), class extends a {
      connectedCallback() {
        var e;
        null != (e = document.getElementById(this.getAttribute("form-id"))) && e.addEventListener("variant:changed", this._onVariantChanged.bind(this));
      }
      _onVariantChanged(e) {
        var t,
          e = e.detail.variant;
        e && ((t = this.querySelector('[name="id"]')).value = e.id, t.dispatchEvent(new Event("change", {
          bubbles: !0
        })));
      }
    }),
    h = (window.customElements.define("product-payment-terms", r), class extends HTMLFormElement {
      connectedCallback() {
        this.id.disabled = !1, this.addEventListener("submit", this._onSubmit.bind(this));
      }
      async _onSubmit(e) {
        if (e.preventDefault(), this.checkValidity()) {
          var e = Array.from(this.elements).filter(e => "submit" === e.type),
            i = (e.forEach(e => {
              e.setAttribute("disabled", "disabled"), e.setAttribute("aria-busy", "true");
            }), new FormData(this)),
            i = (i.append("sections", ["mini-cart"]), i.delete("option1"), i.delete("option2"), i.delete("option3"), await fetch(window.themeVariables.routes.cartAddUrl + ".js", {
              body: i,
              method: "POST",
              headers: {
                "X-Requested-With": "XMLHttpRequest"
              }
            }));
          e.forEach(e => {
            e.removeAttribute("disabled"), e.removeAttribute("aria-busy");
          });
          let t = await i.json();
          if (i.ok) {
            if ("page" === window.themeVariables.settings.cartType || "cart" === window.themeVariables.settings.pageType) return window.location.href = Shopify.routes.root + "cart";
            this.dispatchEvent(new CustomEvent("variant:added", {
              bubbles: !0,
              detail: {
                variant: t.hasOwnProperty("items") ? t.items[0] : t
              }
            })), fetch(window.themeVariables.routes.cartUrl + ".js").then(async e => {
              e = await e.json();
              document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
                bubbles: !0,
                detail: {
                  cart: e
                }
              })), e.sections = t.sections, document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                bubbles: !0,
                detail: {
                  cart: e,
                  openMiniCart: "drawer" === window.themeVariables.settings.cartType && null === this.closest(".drawer")
                }
              }));
            });
          }
          this.dispatchEvent(new CustomEvent("cart-notification:show", {
            bubbles: !0,
            cancelable: !0,
            detail: {
              status: i.ok ? "success" : "error",
              error: t.description || ""
            }
          }));
        } else this.reportValidity();
      }
    }),
    p = (window.customElements.define("product-form", h, {
      extends: "form"
    }), class extends a {
      async connectedCallback() {
        var e;
        this.mainCarousel = this.querySelector("flickity-carousel"), this.hasAttribute("reveal-on-scroll") && this._setupVisibility(), 1 !== this.mainCarousel.childElementCount && (this.selectedVariantMediaId = null, this.viewInSpaceElement = this.querySelector("[data-shopify-model3d-id]"), this.zoomButton = this.querySelector(".product__zoom-button"), this.product = await A.load(this.getAttribute("product-handle")), this._babelioInitialize(), null != (e = document.getElementById(this.getAttribute("form-id"))) && e.addEventListener("variant:changed", this._onVariantChanged.bind(this)), this.mainCarousel.addEventListener("model:played", () => this.mainCarousel.setDraggable(!1)), this.mainCarousel.addEventListener("model:paused", () => this.mainCarousel.setDraggable(!0)), this.mainCarousel.addEventListener("video:played", () => this.mainCarousel.setDraggable(!1)), this.mainCarousel.addEventListener("video:paused", () => this.mainCarousel.setDraggable(!0)), this.mainCarousel.addEventListener("flickity:ready", this._onFlickityReady.bind(this)), this.mainCarousel.addEventListener("flickity:slide-changed", this._onFlickityChanged.bind(this)), this.mainCarousel.addEventListener("flickity:slide-settled", this._onFlickitySettled.bind(this)), this._onFlickityReady());
      }
      get thumbnailsPosition() {
        return window.matchMedia(window.themeVariables.breakpoints.pocket).matches ? "bottom" : this.getAttribute("thumbnails-position");
      }
      async _setupVisibility() {
        await this.untilVisible();
        let e = await this.mainCarousel.flickityInstance,
          t = e ? e.selectedElement.querySelector("img") : this.querySelector(".product__media-image-wrapper img"),
          i = v.prefersReducedMotion();
        await I(t);
        var s = new T(new M([new P(t, {
          opacity: [0, 1],
          transform: [`scale(${i ? 1 : 1.1})`, "scale(1)"]
        }, {
          duration: 500,
          easing: "cubic-bezier(0.65, 0, 0.35, 1)"
        }), new M(Array.from(this.querySelectorAll(".product__thumbnail-item:not(.is-filtered)")).map((e, t) => new P(e, {
          opacity: [0, 1],
          transform: "left" === this.thumbnailsPosition ? [`translateY(${i ? 0 : "40px"})`, "translateY(0)"] : [`translateX(${i ? 0 : "50px"})`, "translateX(0)"]
        }, {
          duration: 250,
          delay: i ? 0 : 100 * t,
          easing: "cubic-bezier(0.75, 0, 0.175, 1)"
        })))]));
        this._hasSectionReloaded ? s.finish() : s.play();
      }
      _babelioInitialize() {
        this._babelioColorOption = this.product.options.find(option => /^(color|colour|颜色)$/i.test(option.name.trim()));
        if (!this._babelioColorOption) return;
        this._babelioItems = Array.from(this.mainCarousel.querySelectorAll('.product__media-item')).sort((a, b) => Number(a.dataset.originalPosition) - Number(b.dataset.originalPosition));
        const form = document.getElementById(this.getAttribute('form-id'));
        const id = form && form.elements.namedItem('id');
        const selected = this.product.variants.find(variant => String(variant.id) === String(id && id.value));
        this._babelioColor = selected ? selected.options[this._babelioColorOption.position - 1] : null;
        this._babelioRevision = 0;
        // Prevent the browser from moving the document's scroll anchor during media filtering.
        if (!document.getElementById('babelio-gallery-anchor-style')) {
          const style = document.createElement('style');
          style.id = 'babelio-gallery-anchor-style';
          style.textContent = 'html.babelio-gallery-page,html.babelio-gallery-page body{overflow-anchor:none!important}';
          document.head.appendChild(style);
        }
        document.documentElement.classList.add('babelio-gallery-page');
        const params = new URLSearchParams(location.search);
        if (selected && params.has('variant') && params.has('utm_source') && String(selected.id) === params.get('variant')) {
          queueMicrotask(() => this._onVariantChanged({
            detail: {
              variant: selected,
              babelioForceColor: true
            }
          }));
        }
      }
      async _onVariantChanged(event) {
        const variant = event.detail && event.detail.variant;
        if (!variant) return;
        if (!this._babelioColorOption) return this._onVariantChangedDefault(event);
        const color = variant.options[this._babelioColorOption.position - 1];
        const sizeChange = !event.detail.babelioForceColor && color === this._babelioColor;
        // Same color: show the image assigned to this exact size variant.
        if (sizeChange && !variant.featured_media) return;
        this._babelioColor = color;
        const revision = ++this._babelioRevision;
        const normalize = value => String(value || '').trim().toLowerCase();
        const tagOf = media => {
          const alt = media.alt || '';
          const hash = alt.lastIndexOf('#');
          const tag = hash < 0 ? '' : alt.slice(hash + 1);
          const separator = tag.indexOf('_');
          return separator < 0 ? null : {
            name: normalize(tag.slice(0, separator)),
            value: normalize(tag.slice(separator + 1))
          };
        };
        const colorName = normalize(this._babelioColorOption.name);
        const matches = this.product.media.filter(media => {
          const tag = tagOf(media);
          return media.media_type === 'image' && tag && tag.name === colorName && tag.value === normalize(color);
        });
        const variantMedia = new Set(this.product.variants.map(v => v.featured_media && String(v.featured_media.id)).filter(Boolean));
        const first = sizeChange ? this.product.media.find(media => String(media.id) === String(variant.featured_media.id)) : matches.find(media => !variantMedia.has(String(media.id))) || matches[0];
        if (!first) {
          // No color set is marked: preserve the theme's normal behavior for this product.
          return this._onVariantChangedDefault(event);
        }
        const hidden = new Set(this.product.media.filter(media => {
          const tag = tagOf(media);
          if (!tag) return false;
          const option = this.product.options.find(item => normalize(item.name) === tag.name);
          return option && normalize(variant.options[option.position - 1]) !== tag.value;
        }).map(media => String(media.id)));
        // A variant's assigned image must remain selectable even if its alt tag is inconsistent.
        hidden.delete(String(first.id));
        const carousel = this.mainCarousel;
        const flkty = await carousel.flickityInstance;
        if (revision !== this._babelioRevision || !this.isConnected || !flkty) return;
        const target = this._babelioItems.find(item => item.dataset.mediaId === String(first.id));
        if (!target) return;
        const previousHeight = carousel.style.height;
        const previousOverflow = carousel.style.overflow;
        const height = carousel.getBoundingClientRect().height;
        if (height) carousel.style.height = height + 'px';
        carousel.style.overflow = 'hidden';
        try {
          this.querySelectorAll('[data-media-id]').forEach(item => {
            item.classList.toggle('is-filtered', hidden.has(item.dataset.mediaId));
          });
          // Reuse the existing Flickity instance; do not destroy it or wait for visibility again.
          this._babelioItems.forEach(item => {
            item.classList.remove('is-selected', 'is-initial-selected');
            flkty.slider.appendChild(item);
          });
          target.classList.add('is-initial-selected');
          flkty.reloadCells();
          flkty.selectCell(target, false, true);
          // A color set can start at the same index as the previous set. Explicitly notify
          // the theme so thumbnails and media controls update even when change did not fire.
          carousel.dispatchEvent(new CustomEvent('flickity:slide-changed', {
            bubbles: true
          }));
          carousel.dispatchEvent(new CustomEvent('flickity:slide-settled', {
            bubbles: true
          }));
          this.selectedVariantMediaId = first.id;
        } finally {
          carousel.style.height = previousHeight;
          carousel.style.overflow = previousOverflow;
        }
      }
      async _onVariantChangedDefault(e) {
        let s = e.detail.variant,
          n = [];
        if (this.product.media.forEach(i => {
          var e,
            t = s.featured_media && i.id === s.featured_media.id;
          if (null != (e = i.alt) && e.includes("#") && !t) {
            let e = i.alt.split("#"),
              t = e.pop().split("_");
            this.product.options.forEach(e => {
              e.name.toLowerCase() === t[0].toLowerCase() && s.options[e.position - 1].toLowerCase() !== t[1].trim().toLowerCase() && n.push(i.id);
            });
          }
        }), [...new Set(Array.from(this.querySelectorAll(".is-filtered[data-media-id]")).map(e => parseInt(e.getAttribute("data-media-id"))))].some(e => !n.includes(e))) {
          let t = s.featured_media ? s.featured_media.id : this.product.media.map(e => e.id).filter(e => !n.includes(e))[0];
          Array.from(this.querySelectorAll("[data-media-id]")).forEach(e => {
            e.classList.toggle("is-filtered", n.includes(parseInt(e.getAttribute("data-media-id")))), e.classList.toggle("is-selected", t === parseInt(e.getAttribute("data-media-id"))), e.classList.toggle("is-initial-selected", t === parseInt(e.getAttribute("data-media-id")));
          }), this.mainCarousel.reload();
        } else {
          if (!e.detail.variant.featured_media || this.selectedVariantMediaId === e.detail.variant.featured_media.id) return;
          this.mainCarousel.select(`[data-media-id="${e.detail.variant.featured_media.id}"]`);
        }
        this.selectedVariantMediaId = e.detail.variant.featured_media ? e.detail.variant.featured_media.id : null;
      }
      async _onFlickityReady() {
        var e = await this.mainCarousel.flickityInstance;
        ["video", "external_video"].includes(e.selectedElement.getAttribute("data-media-type")) && this.hasAttribute("autoplay-video") && e.selectedElement.firstElementChild.play();
      }
      async _onFlickityChanged() {
        (await this.mainCarousel.flickityInstance).cells.forEach(e => {
          ["external_video", "video", "model"].includes(e.element.getAttribute("data-media-type")) && e.element.firstElementChild.pause();
        });
      }
      async _onFlickitySettled() {
        var e = (await this.mainCarousel.flickityInstance).selectedElement;
        switch (this.zoomButton && (this.zoomButton.hidden = "image" !== e.getAttribute("data-media-type")), this.viewInSpaceElement && this.viewInSpaceElement.setAttribute("data-shopify-model3d-id", this.viewInSpaceElement.getAttribute("data-shopify-model3d-default-id")), e.getAttribute("data-media-type")) {
          case "model":
            this.viewInSpaceElement.setAttribute("data-shopify-model3d-id", e.getAttribute("data-media-id")), e.firstElementChild.play();
            break;
          case "external_video":
          case "video":
            this.hasAttribute("autoplay-video") && e.firstElementChild.play();
        }
      }
    });
  function V(e, t = "") {
    "string" == typeof e && (e = e.replace(".", ""));
    var i = /\{\{\s*(\w+)\s*\}\}/,
      t = t || window.themeVariables.settings.moneyFormat;
    function n(e, t) {
      return null == e || e != e ? t : e;
    }
    function s(e, t, i, s) {
      return t = n(t, 2), i = n(i, ","), s = n(s, "."), isNaN(e) || null == e ? 0 : (t = (e = (e / 100).toFixed(t)).split("."))[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (t[1] ? s + t[1] : "");
    }
    let a = "";
    switch (t.match(i)[1]) {
      case "amount":
        a = s(e, 2);
        break;
      case "amount_no_decimals":
        a = s(e, 0);
        break;
      case "amount_with_space_separator":
        a = s(e, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        a = s(e, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        a = s(e, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        a = s(e, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        a = s(e, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        a = s(e, 0, "'");
    }
    return t.indexOf("with_comma_separator"), t.replace(i, a);
  }
  window.customElements.define("product-media", p);
  var r = class extends HTMLElement {
      connectedCallback() {
        var e;
        null != (e = document.getElementById(this.getAttribute("form-id"))) && e.addEventListener("variant:changed", this._onVariantChanged.bind(this));
      }
      get priceClass() {
        return this.getAttribute("price-class") || "";
      }
      get unitPriceClass() {
        return this.getAttribute("unit-price-class") || "";
      }
      _onVariantChanged(e) {
        this._updateLabels(e.detail.variant), this._updatePrices(e.detail.variant), this._updateSku(e.detail.variant);
      }
      _updateLabels(t) {
        var i = this.querySelector("[data-product-label-list]");
        if (i) if (t) {
          if (i.innerHTML = "", t.available) {
            if (t.compare_at_price > t.price) {
              let e = "";
              e = "percentage" === window.themeVariables.settings.discountMode ? Math.round(100 * (t.compare_at_price - t.price) / t.compare_at_price) + "%" : V(t.compare_at_price - t.price), i.innerHTML = `<span class="label label--highlight">${window.themeVariables.strings.collectionDiscount.replace("@savings@", e)}</span>`;
            }
          } else i.innerHTML = `<span class="label label--subdued">${window.themeVariables.strings.collectionSoldOut}</span>`;
        } else i.innerHTML = "";
      }
      _updatePrices(t) {
        var i = this.querySelector("[data-product-price-list]"),
          e = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
        if (i) if (t) {
          if (i.innerHTML = "", t.compare_at_price > t.price ? (i.innerHTML += `<span class="price price--highlight ${this.priceClass}"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${V(t.price, e)}</span>`, i.innerHTML += `<span class="price price--compare"><span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>${V(t.compare_at_price, e)}</span>`) : i.innerHTML += `<span class="price ${this.priceClass}"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${V(t.price, e)}</span>`, t.unit_price_measurement) {
            let e = "";
            1 !== t.unit_price_measurement.reference_value && (e = `<span class="unit-price-measurement__reference-value">${t.unit_price_measurement.reference_value}</span>`), i.innerHTML += `
          <div class="price text--subdued ${this.unitPriceClass}">
            <div class="unit-price-measurement">
              <span class="unit-price-measurement__price">${V(t.unit_price)}</span>
              <span class="unit-price-measurement__separator">/</span>
              ${e}
              <span class="unit-price-measurement__reference-unit">${t.unit_price_measurement.reference_unit}</span>
            </div>
          </div>
        `;
          }
          i.style.display = "";
        } else i.style.display = "none";
      }
      _updateSku(e) {
        var t,
          i = this.querySelector("[data-product-sku-container]");
        i && (t = i.querySelector("[data-product-sku-number]"), e && e.sku ? (t.innerHTML = e.sku, i.style.display = "") : i.style.display = "none");
      }
    },
    h = (window.customElements.define("product-meta", r), class extends u {
      connectedCallback() {
        super.connectedCallback(), this.delegate.on("variant:changed", this._onVariantChanged.bind(this));
      }
      async _load() {
        await super._load(), this.imageElement = this.querySelector(".quick-buy-product__image"), window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init();
      }
      _onVariantChanged(e) {
        let i = e.detail.variant;
        i && Array.from(this.querySelectorAll('[href*="/products"]')).forEach(e => {
          var t = new URL(e.href);
          t.searchParams.set("variant", i.id), e.setAttribute("href", t.toString());
        }), this.imageElement && i && i.featured_media && ((e = i.featured_media).alt && this.imageElement.setAttribute("alt", e.alt), this.imageElement.setAttribute("width", e.preview_image.width), this.imageElement.setAttribute("height", e.preview_image.height), this.imageElement.setAttribute("src", k(e, "342x")), this.imageElement.setAttribute("srcset", C(e, [114, 228, 342])));
      }
    }),
    p = (window.customElements.define("quick-buy-drawer", h), class extends m {
      connectedCallback() {
        super.connectedCallback(), this.delegate.on("variant:changed", this._onVariantChanged.bind(this)), this.delegate.on("variant:added", () => this.open = !1);
      }
      async _load() {
        await super._load(), this.imageElement = this.querySelector(".quick-buy-product__image");
      }
      _onVariantChanged(e) {
        let i = e.detail.variant;
        i && Array.from(this.querySelectorAll('[href*="/products"]')).forEach(e => {
          var t = new URL(e.href);
          t.searchParams.set("variant", i.id), e.setAttribute("href", t.toString());
        }), this.imageElement && i && i.featured_media && ((e = i.featured_media).alt && this.imageElement.setAttribute("alt", e.alt), this.imageElement.setAttribute("width", e.preview_image.width), this.imageElement.setAttribute("height", e.preview_image.height), this.imageElement.setAttribute("src", k(e, "195x")), this.imageElement.setAttribute("srcset", C(e, [65, 130, 195])));
      }
    }),
    r = (window.customElements.define("quick-buy-popover", p), class extends HTMLElement {
      connectedCallback() {
        var e;
        null != (e = document.getElementById(this.getAttribute("form-id"))) && e.addEventListener("variant:changed", this._onVariantChanged.bind(this));
      }
      _onVariantChanged(e) {
        e.detail.variant ? this._renderForVariant(e.detail.variant.id) : this.innerHTML = "";
      }
      async _renderForVariant(e) {
        var e = await fetch(window.themeVariables.routes.rootUrlWithoutSlash + `/variants/${e}?section_id=store-availability`),
          t = document.createElement("div");
        t.innerHTML = await e.text(), this.innerHTML = t.firstElementChild.innerHTML.trim();
      }
    }),
    h = (window.customElements.define("store-pickup", r), class extends a {
      async connectedCallback() {
        this.masterSelector = document.getElementById(this.getAttribute("form-id")).id, this.optionSelectors = Array.from(this.querySelectorAll("[data-selector-type]")), this.masterSelector ? (this.product = await A.load(this.productHandle), this.delegate.on("change", '[name^="option"]', this._onOptionChanged.bind(this)), this.masterSelector.addEventListener("change", this._onMasterSelectorChanged.bind(this)), this._updateDisableSelectors(), this.selectVariant(this.selectedVariant.id)) : console.warn(`The variant selector for product with handle ${this.productHandle} is not linked to any product form.`);
      }
      get selectedVariant() {
        return this._getVariantById(parseInt(this.masterSelector.value));
      }
      get productHandle() {
        return this.getAttribute("handle");
      }
      get hideSoldOutVariants() {
        return this.hasAttribute("hide-sold-out-variants");
      }
      get updateUrl() {
        return this.hasAttribute("update-url");
      }
      selectVariant(e) {
        var t;
        this._isVariantSelectable(this._getVariantById(e)) || (e = this._getFirstMatchingAvailableOrSelectableVariant().id), (null == (t = this.selectedVariant) ? void 0 : t.id) !== e && (this.masterSelector.value = e, this.masterSelector.dispatchEvent(new Event("change", {
          bubbles: !0
        })), this.updateUrl && history.replaceState && (t = new URL(window.location.href), e ? t.searchParams.set("variant", e) : t.searchParams.delete("variant"), window.history.replaceState({
          path: t.toString()
        }, "", t.toString())), this._updateDisableSelectors(), n(this.masterSelector.form, "variant:changed", {
          variant: this.selectedVariant
        }));
      }
      _onOptionChanged() {
        var e;
        this.selectVariant(null == (e = this._getVariantFromOptions()) ? void 0 : e.id);
      }
      _onMasterSelectorChanged() {
        var e;
        ((null == (e = this.selectedVariant) ? void 0 : e.options) || []).forEach((e, t) => {
          let i = this.querySelector(`input[name="option${t + 1}"][value="${CSS.escape(e)}"], select[name="option${t + 1}"]`),
            s = !1;
          "SELECT" === i.tagName ? (s = i.value !== e, i.value = e) : "INPUT" === i.tagName && (s = !i.checked && i.value === e, i.checked = i.value === e), s && i.dispatchEvent(new Event("change", {
            bubbles: !0
          }));
        });
      }
      _getVariantById(t) {
        return this.product.variants.find(e => e.id === t);
      }
      _getVariantFromOptions() {
        let i = this._getSelectedOptionValues();
        return this.product.variants.find(e => e.options.every((e, t) => e === i[t]));
      }
      _isVariantSelectable(e) {
        return !!e && (e.available || !this.hideSoldOutVariants && !e.available);
      }
      _getFirstMatchingAvailableOrSelectableVariant() {
        let i = this._getSelectedOptionValues(),
          e = null,
          t = 0;
        for (; i.pop(), t += 1, !(e = this.product.variants.find(e => this.hideSoldOutVariants ? e.available && e.options.slice(0, e.options.length - t).every((e, t) => e === i[t]) : e.options.slice(0, e.options.length - t).every((e, t) => e === i[t]))) && 0 < i.length;);
        return e;
      }
      _getSelectedOptionValues() {
        let t = [];
        return Array.from(this.querySelectorAll('input[name^="option"]:checked, select[name^="option"]')).forEach(e => t.push(e.value)), t;
      }
      _updateDisableSelectors() {
        let a = this.selectedVariant;
        if (a) {
          let n = (e, t, i, s) => {
            let n = e.getAttribute("data-selector-type"),
              a = "";
            switch (n) {
              case "color":
                a = `.color-swatch:nth-child(${t + 1})`;
                break;
              case "variant-image":
                a = `.variant-swatch:nth-child(${t + 1})`;
                break;
              case "block":
                a = `.block-swatch:nth-child(${t + 1})`;
                break;
              case "dropdown":
                a = `.combo-box__option-item:nth-child(${t + 1})`;
            }
            e.querySelector(a).toggleAttribute("hidden", !s), this.hideSoldOutVariants ? e.querySelector(a).toggleAttribute("hidden", !i) : e.querySelector(a).classList.toggle("is-disabled", !i);
          };
          this.optionSelectors && this.optionSelectors[0] && this.product.options[0].values.forEach((t, e) => {
            var i = this.product.variants.some(e => e.option1 === t && e),
              s = this.product.variants.some(e => e.option1 === t && e.available);
            n(this.optionSelectors[0], e, s, i), this.optionSelectors[1] && this.product.options[1].values.forEach((t, e) => {
              var i = this.product.variants.some(e => e.option2 === t && e.option1 === a.option1 && e),
                s = this.product.variants.some(e => e.option2 === t && e.option1 === a.option1 && e.available);
              n(this.optionSelectors[1], e, s, i), this.optionSelectors[2] && this.product.options[2].values.forEach((t, e) => {
                var i = this.product.variants.some(e => e.option3 === t && e.option1 === a.option1 && e.option2 === a.option2 && e),
                  s = this.product.variants.some(e => e.option3 === t && e.option1 === a.option1 && e.option2 === a.option2 && e.available);
                n(this.optionSelectors[2], e, s, i);
              });
            });
          });
        }
      }
    }),
    p = (window.customElements.define("product-variants", h), class extends a {
      connectedCallback() {
        this.primaryImageList = Array.from(this.querySelectorAll(".product-item__primary-image")), this.delegate.on("change", ".product-item-meta__swatch-list .color-swatch__radio", this._onColorSwatchChanged.bind(this)), this.delegate.on("mouseenter", ".product-item-meta__swatch-list .color-swatch__item", this._onColorSwatchHovered.bind(this), !0);
      }
      async _onColorSwatchChanged(e, i) {
        if (Array.from(this.querySelectorAll('[href*="/products"]')).forEach(e => {
          let t;
          (t = "A" === e.tagName ? new URL(e.href) : new URL(e.getAttribute("href"), "https://" + window.themeVariables.routes.host)).searchParams.set("variant", i.getAttribute("data-variant-id")), e.setAttribute("href", t.toString());
        }), i.hasAttribute("data-variant-featured-media")) {
          let t = this.primaryImageList.find(e => e.getAttribute("data-media-id") === i.getAttribute("data-variant-featured-media"));
          t.setAttribute("loading", "eager"), await (t.complete ? Promise.resolve() : new Promise(e => t.onload = e)), t.removeAttribute("hidden");
          let e = {};
          e = Array.from(t.parentElement.classList).some(e => ["aspect-ratio--short", "aspect-ratio--tall", "aspect-ratio--square"].includes(e)) ? [{
            clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
            transform: "translate(calc(-50% - 20px), -50%)",
            zIndex: 1,
            offset: 0
          }, {
            clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
            transform: "translate(calc(-50% - 20px), -50%)",
            zIndex: 1,
            offset: .3
          }, {
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
            transform: "translate(-50%, -50%)",
            zIndex: 1,
            offset: 1
          }] : [{
            clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
            transform: "translateX(-20px)",
            zIndex: 1,
            offset: 0
          }, {
            clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
            transform: "translateX(-20px)",
            zIndex: 1,
            offset: .3
          }, {
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
            transform: "translateX(0px)",
            zIndex: 1,
            offset: 1
          }], await t.animate(e, {
            duration: 500,
            easing: "ease-in-out"
          }).finished, this.primaryImageList.filter(e => e.classList.contains("product-item__primary-image") && e !== t).forEach(e => e.setAttribute("hidden", ""));
        }
      }
      _onColorSwatchHovered(e, t) {
        let i = t.previousElementSibling;
        i.hasAttribute("data-variant-featured-media") && this.primaryImageList.find(e => e.getAttribute("data-media-id") === i.getAttribute("data-variant-featured-media")).setAttribute("loading", "eager");
      }
    }),
    r = (window.customElements.define("product-item", p), class extends a {
      connectedCallback() {
        this.delegate.on("pagination:page-changed", this._rerender.bind(this)), this.delegate.on("facet:criteria-changed", this._rerender.bind(this)), this.delegate.on("facet:abort-loading", this._abort.bind(this));
      }
      async _rerender(t) {
        history.replaceState({}, "", t.detail.url), this._abort(), this.showLoadingBar();
        t = new URL(window.location);
        t.searchParams.set("section_id", this.getAttribute("section-id"));
        try {
          this.abortController = new AbortController();
          var s,
            n = await (await fetch(t.toString(), {
              signal: this.abortController.signal
            })).text(),
            a = document.createElement("div"),
            r = (a.innerHTML = n, this.querySelector("#facet-main").innerHTML = a.querySelector("#facet-main").innerHTML, Array.from(a.querySelectorAll(".product-facet__active-list"))),
            o = document.querySelector(".mobile-toolbar__item--filters");
          o && o.classList.toggle("has-filters", 0 < r.length);
          let i = a.querySelector("#facet-filters"),
            e = (i && (s = this.querySelector("#facet-filters .drawer__content").scrollTop, Array.from(this.querySelectorAll("#facet-filters-form .collapsible-toggle[aria-controls]")).forEach(e => {
              var t = i.querySelector(`[aria-controls="${e.getAttribute("aria-controls")}"]`),
                e = "true" === e.getAttribute("aria-expanded");
              t.setAttribute("aria-expanded", e ? "true" : "false"), t.nextElementSibling.toggleAttribute("open", e), t.nextElementSibling.style.overflow = e ? "visible" : "";
            }), this.querySelector("#facet-filters").innerHTML = i.innerHTML, this.querySelector("#facet-filters .drawer__content").scrollTop = s), this.querySelector(".product-facet__meta-bar") || this.querySelector(".product-facet__product-list") || this.querySelector(".product-facet__main"));
          requestAnimationFrame(() => {
            e.scrollIntoView({
              block: "start",
              behavior: "smooth"
            });
          }), this.hideLoadingBar();
        } catch (e) {
          e.name;
        }
      }
      _abort() {
        this.abortController && this.abortController.abort();
      }
    }),
    h = (window.customElements.define("product-facet", r), class extends u {
      connectedCallback() {
        super.connectedCallback(), this.delegate.on("change", '[name^="filter."]', this._onFilterChanged.bind(this)), this.rootDelegate.on("click", '[data-action="clear-filters"]', this._onFiltersCleared.bind(this)), this.alwaysVisible && (this.matchMedia = window.matchMedia(window.themeVariables.breakpoints.pocket), this.matchMedia.addListener(this._adjustDrawer.bind(this)), this._adjustDrawer(this.matchMedia));
      }
      get alwaysVisible() {
        return this.hasAttribute("always-visible");
      }
      _onFiltersCleared(e, t) {
        e.preventDefault(), n(this, "facet:criteria-changed", {
          url: t.href
        });
      }
      _onFilterChanged() {
        var e = new FormData(this.querySelector("#facet-filters-form")),
          e = new URLSearchParams(e).toString();
        n(this, "facet:criteria-changed", {
          url: window.location.pathname + "?" + e
        });
      }
      _adjustDrawer(e) {
        this.classList.toggle("drawer", e.matches), this.classList.toggle("drawer--from-left", e.matches);
      }
    }),
    p = (window.customElements.define("facet-filters", h), class extends m {
      connectedCallback() {
        super.connectedCallback(), this.delegate.on("change", '[name="sort_by"]', this._onSortChanged.bind(this));
      }
      _onSortChanged(e, t) {
        var i = new URL(location.href);
        i.searchParams.set("sort_by", t.value), i.searchParams.delete("page"), this.open = !1, this.dispatchEvent(new CustomEvent("facet:criteria-changed", {
          bubbles: !0,
          detail: {
            url: i.toString()
          }
        }));
      }
    }),
    r = (window.customElements.define("sort-by-popover", p), class extends a {
      connectedCallback() {
        this.rootDelegate.on("cart:updated", e => this.innerText = e.detail.cart.item_count), this.rootDelegate.on("cart:refresh", this._updateCartCount.bind(this));
      }
      _updateCartCount(e) {
        var t;
        null != (t = null == e ? void 0 : e.detail) && t.cart ? this.innerText = e.detail.cart.item_count : fetch(Shopify.routes.root + "cart.js").then(e => {
          e.json().then(e => {
            this.innerText = e.item_count;
          });
        });
      }
    }),
    h = (window.customElements.define("cart-count", r), class extends u {
      connectedCallback() {
        super.connectedCallback(), this.nextReplacementDelay = 0, this.rootDelegate.on("cart:refresh", this._rerenderCart.bind(this)), this.addEventListener("variant:added", () => this.nextReplacementDelay = 600);
      }
      async _rerenderCart(i) {
        let e,
          s = null,
          t = "";
        t = i.detail && i.detail.cart && i.detail.cart.sections ? (s = i.detail.cart, i.detail.cart.sections["mini-cart"]) : await (await fetch(window.themeVariables.routes.cartUrl + "?section_id=" + this.getAttribute("section"))).text();
        let n = document.createElement("div");
        n.innerHTML = t, setTimeout(async () => {
          var e,
            t = this.querySelector(".drawer__content").scrollTop;
          s && 0 === s.item_count && ((e = new T(new M(Array.from(this.querySelectorAll(".drawer__content, .drawer__footer")).map(e => new P(e, {
            opacity: [1, 0]
          }, {
            duration: 250,
            easing: "ease-in"
          }))))).play(), await e.finished), this.innerHTML = n.querySelector("cart-drawer").innerHTML, s && 0 === s.item_count ? this.querySelector(".drawer__content").animate({
            opacity: [0, 1],
            transform: ["translateY(40px)", "translateY(0)"]
          }, {
            duration: 450,
            easing: "cubic-bezier(0.33, 1, 0.68, 1)"
          }) : this.querySelector(".drawer__content").scrollTop = t, null != (e = null == i ? void 0 : i.detail) && e.openMiniCart && (this.clientWidth, this.open = !0);
        }, (null == (e = null == i ? void 0 : i.detail) ? void 0 : e.replacementDelay) || this.nextReplacementDelay), this.nextReplacementDelay = 0;
      }
      async attributeChangedCallback(e, t, i) {
        var s;
        super.attributeChangedCallback(e, t, i), "open" === e && this.open && (this.querySelector(".drawer__content").scrollTop = 0, v.prefersReducedMotion() || (t = Array.from(this.querySelectorAll(".line-item")), i = this.querySelector(".mini-cart__recommendations-inner"), e = this.querySelector(".drawer__footer"), s = [], i && window.matchMedia(window.themeVariables.breakpoints.pocket).matches && t.push(i), t.forEach(e => e.style.opacity = 0), i && (i.style.opacity = 0), e && (e.style.opacity = 0), s.push(new M(t.map((e, t) => new P(e, {
          opacity: [0, 1],
          transform: ["translateX(40px)", "translateX(0)"]
        }, {
          duration: 400,
          delay: 400 + 120 * t - Math.min(2 * t * t, 120 * t),
          easing: "cubic-bezier(0.25, 1, 0.5, 1)"
        })))), e && s.push(new P(e, {
          opacity: [0, 1],
          transform: ["translateY(100%)", "translateY(0)"]
        }, {
          duration: 300,
          delay: 400,
          easing: "cubic-bezier(0.25, 1, 0.5, 1)"
        })), i && !window.matchMedia(window.themeVariables.breakpoints.pocket).matches && s.push(new P(i, {
          opacity: [0, 1],
          transform: ["translateX(100%)", "translateX(0)"]
        }, {
          duration: 250,
          delay: 400 + Math.max(120 * t.length - 25 * t.length, 25),
          easing: "cubic-bezier(0.25, 1, 0.5, 1)"
        })), new T(new M(s)).play()));
      }
    }),
    O = (window.customElements.define("cart-drawer", h), class extends HTMLElement {
      async connectedCallback() {
        O.recommendationsCache[this.productId] || (O.recommendationsCache[this.productId] = fetch(`${window.themeVariables.routes.productRecommendationsUrl}?product_id=${this.productId}&limit=10&section_id=` + this.sectionId));
        var e = await O.recommendationsCache[this.productId],
          t = document.createElement("div"),
          e = (t.innerHTML = await e.clone().text(), t.querySelector("cart-drawer-recommendations"));
        e && e.hasChildNodes() ? this.innerHTML = e.innerHTML : this.hidden = !0;
      }
      get productId() {
        return this.getAttribute("product-id");
      }
      get sectionId() {
        return this.getAttribute("section-id");
      }
    }),
    m = O,
    p = (e(m, "recommendationsCache", {}), window.customElements.define("cart-drawer-recommendations", m), class extends HTMLTextAreaElement {
      connectedCallback() {
        this.addEventListener("change", this._onNoteChanged.bind(this));
      }
      get ownedToggle() {
        return this.hasAttribute("aria-owns") ? document.getElementById(this.getAttribute("aria-owns")) : null;
      }
      async _onNoteChanged() {
        this.ownedToggle && (this.ownedToggle.innerHTML = "" === this.value ? window.themeVariables.strings.cartAddOrderNote : window.themeVariables.strings.cartEditOrderNote);
        var e = await (await fetch(window.themeVariables.routes.cartUrl + "/update.js", {
          body: JSON.stringify({
            note: this.value
          }),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          }
        })).json();
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
          bubbles: !0,
          detail: {
            cart: e
          }
        }));
      }
    }),
    r = (window.customElements.define("cart-note", p, {
      extends: "textarea"
    }), class extends HTMLElement {
      connectedCallback() {
        document.documentElement.addEventListener("cart:updated", this._onCartUpdated.bind(this));
      }
      get threshold() {
        return parseFloat(this.getAttribute("threshold"));
      }
      _onCartUpdated(e) {
        e = e.detail.cart.items.filter(e => e.requires_shipping).reduce((e, t) => e + t.final_line_price, 0);
        this.style.setProperty("--progress", Math.min(e / this.threshold, 1));
      }
    }),
    u = (window.customElements.define("free-shipping-bar", r), class extends a {
      connectedCallback() {
        this.delegate.on("click", "a", this._onQuantityLinkClicked.bind(this)), this.delegate.on("change", "input", this._onQuantityChanged.bind(this));
      }
      _onQuantityLinkClicked(e, t) {
        e.preventDefault(), this._updateFromLink(t.href);
      }
      _onQuantityChanged(e, t) {
        this._updateFromLink(`${window.themeVariables.routes.cartChangeUrl}?quantity=${t.value}&line=` + t.getAttribute("data-line"));
      }
      async _updateFromLink(e) {
        var t, i;
        "cart" === window.themeVariables.settings.pageType ? window.location.href = e : (i = (e = new URL(e, "https://" + window.themeVariables.routes.host).searchParams).get("line"), t = e.get("id"), e = parseInt(e.get("quantity")), this.dispatchEvent(new CustomEvent("line-item-quantity:change:start", {
          bubbles: !0,
          detail: {
            newLineQuantity: e
          }
        })), i = await (await fetch(window.themeVariables.routes.cartChangeUrl + ".js", {
          body: JSON.stringify({
            line: i,
            id: t,
            quantity: e,
            sections: ["mini-cart"]
          }),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          }
        })).json(), this.dispatchEvent(new CustomEvent("line-item-quantity:change:end", {
          bubbles: !0,
          detail: {
            cart: i,
            newLineQuantity: e
          }
        })), document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
          bubbles: !0,
          detail: {
            cart: i
          }
        })), document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: !0,
          detail: {
            cart: i,
            replacementDelay: 0 === e ? 600 : 750
          }
        })));
      }
    }),
    h = (window.customElements.define("line-item-quantity", u), class extends HTMLElement {
      connectedCallback() {
        this.lineItemLoader = this.querySelector(".line-item__loader"), this.addEventListener("line-item-quantity:change:start", this._onQuantityStart.bind(this)), this.addEventListener("line-item-quantity:change:end", this._onQuantityEnd.bind(this));
      }
      _onQuantityStart() {
        this.lineItemLoader && (this.lineItemLoader.hidden = !1, this.lineItemLoader.firstElementChild.hidden = !1, this.lineItemLoader.lastElementChild.hidden = !0);
      }
      async _onQuantityEnd(e) {
        0 !== e.detail.cart.item_count && this.lineItemLoader && (await this.lineItemLoader.firstElementChild.animate({
          opacity: [1, 0],
          transform: ["translateY(0)", "translateY(-10px)"]
        }, 75).finished, this.lineItemLoader.firstElementChild.hidden = !0, 0 === e.detail.newLineQuantity ? (await this.animate({
          opacity: [1, 0],
          height: [this.clientHeight + "px", 0]
        }, {
          duration: 300,
          easing: "ease"
        }).finished, this.remove()) : (this.lineItemLoader.lastElementChild.hidden = !1, await this.lineItemLoader.lastElementChild.animate({
          opacity: [0, 1],
          transform: ["translateY(10px)", "translateY(0)"]
        }, {
          duration: 75,
          endDelay: 300
        }).finished, this.lineItemLoader.hidden = !0));
      }
    }),
    e = (window.customElements.define("line-item", h), class extends a {
      connectedCallback() {
        this.rootDelegate.on("cart-notification:show", this._onShow.bind(this), !this.hasAttribute("global")), this.delegate.on("click", '[data-action="close"]', e => {
          e.stopPropagation(), this.hidden = !0;
        }), this.addEventListener("mouseenter", this.stopTimer.bind(this)), this.addEventListener("mouseleave", this.startTimer.bind(this)), window.addEventListener("pagehide", () => this.hidden = !0);
      }
      set hidden(e) {
        e ? this.stopTimer() : this.startTimer(), this.toggleAttribute("hidden", e);
      }
      get isInsideDrawer() {
        return this.classList.contains("cart-notification--drawer");
      }
      stopTimer() {
        clearTimeout(this._timeout);
      }
      startTimer() {
        this._timeout = setTimeout(() => this.hidden = !0, 3e3);
      }
      _onShow(t) {
        if ((!this.isInsideDrawer || this.closest(".drawer").open) && (!this.hasAttribute("global") || "success" !== t.detail.status || "drawer" !== window.themeVariables.settings.cartType)) {
          t.stopPropagation();
          let e = "";
          this.isInsideDrawer || (e = `
        <button class="cart-notification__close tap-area hidden-phone" data-action="close">
          <span class="visually-hidden">${window.themeVariables.strings.accessibilityClose}</span>
          <svg focusable="false" width="14" height="14" class="icon icon--close icon--inline" viewBox="0 0 14 14">
            <path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"></path>
          </svg>
        </button>
      `), "success" === t.detail.status ? (this.classList.remove("cart-notification--error"), this.innerHTML = `
        <div class="cart-notification__overflow">
          <div class="container">
            <div class="cart-notification__wrapper">
              <svg focusable="false" width="20" height="20" class="icon icon--cart-notification" viewBox="0 0 20 20">
                <rect width="20" height="20" rx="10" fill="currentColor"></rect>
                <path d="M6 10L9 13L14 7" fill="none" stroke="rgb(var(--success-color))" stroke-width="2"></path>
              </svg>
              
              <div class="cart-notification__text-wrapper">
                <span class="cart-notification__heading heading hidden-phone">${window.themeVariables.strings.cartItemAdded}</span>
                <span class="cart-notification__heading heading hidden-tablet-and-up">${window.themeVariables.strings.cartItemAddedShort}</span>
                <a href="${window.themeVariables.routes.cartUrl}" class="cart-notification__view-cart link">${window.themeVariables.strings.cartViewCart}</a>
              </div>
              
              ${e}
            </div>
          </div>
        </div>
      `) : (this.classList.add("cart-notification--error"), this.innerHTML = `
        <div class="cart-notification__overflow">
          <div class="container">
            <div class="cart-notification__wrapper">
              <svg focusable="false" width="20" height="20" class="icon icon--cart-notification" viewBox="0 0 20 20">
                <rect width="20" height="20" rx="10" fill="currentColor"></rect>
                <path d="M9.6748 13.2798C9.90332 13.0555 10.1763 12.9434 10.4937 12.9434C10.811 12.9434 11.0819 13.0555 11.3062 13.2798C11.5347 13.5041 11.6489 13.7749 11.6489 14.0923C11.6489 14.4097 11.5347 14.6847 11.3062 14.9175C11.0819 15.146 10.811 15.2603 10.4937 15.2603C10.1763 15.2603 9.90332 15.146 9.6748 14.9175C9.45052 14.6847 9.33838 14.4097 9.33838 14.0923C9.33838 13.7749 9.45052 13.5041 9.6748 13.2798ZM9.56689 12.1816V5.19922H11.4141V12.1816H9.56689Z" fill="rgb(var(--error-color))"></path>
              </svg>
              
              <div class="cart-notification__text-wrapper">
                <span class="cart-notification__heading heading">${t.detail.error}</span>
              </div>
              
              ${e}
            </div>
          </div>
        </div>
      `), this.clientHeight, this.hidden = !1;
        }
      }
    }),
    m = (window.customElements.define("cart-notification", e), class extends HTMLElement {
      connectedCallback() {
        this.submitButton = this.querySelector('[type="button"]'), this.submitButton.addEventListener("click", this._estimateShipping.bind(this));
      }
      async _estimateShipping() {
        var e = this.querySelector('[name="shipping-estimator[zip]"]').value,
          t = this.querySelector('[name="shipping-estimator[country]"]').value,
          i = this.querySelector('[name="shipping-estimator[province]"]').value,
          s = (this.submitButton.setAttribute("aria-busy", "true"), await fetch(window.themeVariables.routes.cartUrl + `/prepare_shipping_rates.json?shipping_address[zip]=${e}&shipping_address[country]=${t}&shipping_address[province]=` + i, {
            method: "POST"
          }));
        s.ok ? (e = await this._getAsyncShippingRates(e, t, i), this._formatShippingRates(e)) : (t = await s.json(), this._formatError(t)), this.submitButton.removeAttribute("aria-busy");
      }
      async _getAsyncShippingRates(e, t, i) {
        var s = await (await fetch(window.themeVariables.routes.cartUrl + `/async_shipping_rates.json?shipping_address[zip]=${e}&shipping_address[country]=${t}&shipping_address[province]=` + i)).text();
        return "null" === s ? this._getAsyncShippingRates(e, t, i) : JSON.parse(s).shipping_rates;
      }
      _formatShippingRates(e) {
        null != (i = this.querySelector(".shipping-estimator__results")) && i.remove();
        let t = "";
        e.forEach(e => {
          t += `<li>${e.presentment_name}: ${V(100 * parseFloat(e.price))}</li>`;
        });
        var i = `
      <div class="shipping-estimator__results">
        <p>${0 === e.length ? window.themeVariables.strings.shippingEstimatorNoResults : 1 === e.length ? window.themeVariables.strings.shippingEstimatorOneResult : window.themeVariables.strings.shippingEstimatorMultipleResults}</p>
        ${"" === t ? "" : `<ul class="unordered-list">${t}</ul>`}
      </div>
    `;
        this.insertAdjacentHTML("beforeend", i);
      }
      _formatError(t) {
        null != (e = this.querySelector(".shipping-estimator__results")) && e.remove();
        let i = "";
        Object.keys(t).forEach(e => {
          i += `<li>${e} ${t[e]}</li>`;
        });
        var e = `
      <div class="shipping-estimator__results">
        <p>${window.themeVariables.strings.shippingEstimatorError}</p>
        <ul class="unordered-list">${i}</ul>
      </div>
    `;
        this.insertAdjacentHTML("beforeend", e);
      }
    }),
    p = (window.customElements.define("shipping-estimator", m), class extends HTMLAnchorElement {
      constructor() {
        super(), this.addEventListener("click", this._onClick.bind(this));
      }
      _onClick() {
        var e = document.getElementById("shopify-product-reviews");
        e && (window.matchMedia(window.themeVariables.breakpoints.pocket).matches ? e.closest("collapsible-content").open = !0 : document.querySelector(`[aria-controls="${e.closest(".product-tabs__tab-item-wrapper").id}"]`).click());
      }
    }),
    r = (window.customElements.define("review-link", p, {
      extends: "a"
    }), class extends HTMLElement {
      connectedCallback() {
        var e;
        null != (e = document.getElementById(this.getAttribute("form-id"))) && e.addEventListener("variant:changed", this._onVariantChanged.bind(this)), this.imageElement = this.querySelector(".product-sticky-form__image"), this.priceElement = this.querySelector(".product-sticky-form__price"), this.unitPriceElement = this.querySelector(".product-sticky-form__unit-price"), this._setupVisibilityObservers();
      }
      disconnectedCallback() {
        this.intersectionObserver.disconnect();
      }
      set hidden(e) {
        this.toggleAttribute("hidden", e), e ? document.documentElement.style.removeProperty("--cart-notification-offset") : document.documentElement.style.setProperty("--cart-notification-offset", this.clientHeight + "px");
      }
      _onVariantChanged(t) {
        var t = t.detail.variant,
          e = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
        if (t) {
          if (this.priceElement && (this.priceElement.innerHTML = V(t.price, e)), this.unitPriceElement && (this.unitPriceElement.style.display = t.unit_price_measurement ? "block" : "none", t.unit_price_measurement)) {
            let e = "";
            1 !== t.unit_price_measurement.reference_value && (e = `<span class="unit-price-measurement__reference-value">${t.unit_price_measurement.reference_value}</span>`), this.unitPriceElement.innerHTML = `
          <div class="unit-price-measurement">
            <span class="unit-price-measurement__price">${V(t.unit_price)}</span>
            <span class="unit-price-measurement__separator">/</span>
            ${e}
            <span class="unit-price-measurement__reference-unit">${t.unit_price_measurement.reference_unit}</span>
          </div>
        `;
          }
          this.imageElement && t && t.featured_media && ((e = t.featured_media).alt && this.imageElement.setAttribute("alt", e.alt), this.imageElement.setAttribute("width", e.preview_image.width), this.imageElement.setAttribute("height", e.preview_image.height), this.imageElement.setAttribute("src", k(e, "165x")), this.imageElement.setAttribute("srcset", C(e, [55, 110, 165])));
        }
      }
      _setupVisibilityObservers() {
        let i = document.getElementById("MainPaymentContainer"),
          s = document.querySelector(".shopify-section--footer"),
          n = b();
        this._isFooterVisible = this._isPaymentContainerPassed = !1, this.intersectionObserver = new IntersectionObserver(e => {
          e.forEach(e => {
            var t;
            e.target === s && (this._isFooterVisible = 0 < e.intersectionRatio), e.target === i && (t = i.getBoundingClientRect(), this._isPaymentContainerPassed = 0 === e.intersectionRatio && t.top + t.height <= n);
          }), window.matchMedia(window.themeVariables.breakpoints.pocket).matches ? this.hidden = !this._isPaymentContainerPassed || this._isFooterVisible : this.hidden = !this._isPaymentContainerPassed;
        }, {
          rootMargin: `-${n}px 0px 0px 0px`
        }), this.intersectionObserver.observe(i), this.intersectionObserver.observe(s);
      }
    });
  window.customElements.define("product-sticky-form", r), new R(), Shopify.designMode && document.addEventListener("shopify:section:load", () => {
    window.SPR && (window.SPR.initDomEls(), window.SPR.loadProducts());
  }), window.SPRCallbacks = {
    onFormSuccess: (e, t) => {
      document.getElementById("form_" + t.id).classList.add("spr-form--success");
    }
  };
  {
    let i = window.visualViewport ? window.visualViewport.width : document.documentElement.clientWidth;
    (u = () => {
      let e = window.visualViewport ? window.visualViewport.width : document.documentElement.clientWidth,
        t = window.visualViewport ? window.visualViewport.height : document.documentElement.clientHeight;
      e !== i && requestAnimationFrame(() => {
        document.documentElement.style.setProperty("--window-height", t + "px"), i = e;
      });
    })(), (window.visualViewport || window).addEventListener("resize", u);
  }
  (h = new i(document.body)).on("keyup", 'input:not([type="checkbox"]):not([type="radio"]), textarea', (e, t) => {
    t.classList.toggle("is-filled", "" !== t.value);
  }), h.on("change", "select", (e, t) => {
    t.parentNode.classList.toggle("is-filled", "" !== t.value);
  }), document.querySelectorAll(".rte table").forEach(e => {
    e.outerHTML = '<div class="table-wrapper">' + e.outerHTML + "</div>";
  }), document.querySelectorAll(".rte iframe").forEach(e => {
    -1 === e.src.indexOf("youtube") && -1 === e.src.indexOf("youtu.be") && -1 === e.src.indexOf("vimeo") || (e.outerHTML = '<div class="video-wrapper">' + e.outerHTML + "</div>");
  }), new i(document.documentElement).on("click", "[data-smooth-scroll]", (e, t) => {
    t = document.querySelector(t.getAttribute("href"));
    t && (e.preventDefault(), t.scrollIntoView({
      behavior: "smooth",
      block: "start"
    }));
  }), document.addEventListener("keyup", function (e) {
    "Tab" === e.key && (document.body.classList.remove("no-focus-outline"), document.body.classList.add("focus-outline"));
  });
})();
